import { SelectionChange, SelectionModel } from '@angular/cdk/collections';
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  DragDropModule,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  HostBinding,
  HostListener,
  NgZone,
  ViewChild,
  ViewChildren,
  computed,
  effect,
  inject,
  input,
  model,
  output,
  signal,
  untracked,
  viewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MatBadgeModule } from '@angular/material/badge';
import {
  MatButton,
  MatButtonModule,
  MatIconButton,
} from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatChip, MatChipListbox } from '@angular/material/chips';
import { MAT_DATE_LOCALE, MatOption } from '@angular/material/core';
import {
  MatDateRangeInput,
  MatDateRangePicker,
  MatDatepickerToggle,
  MatEndDate,
  MatStartDate,
} from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import {
  MatMenu,
  MatMenuContent,
  MatMenuItem,
  MatMenuTrigger,
} from '@angular/material/menu';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatFooterCell,
  MatFooterCellDef,
  MatFooterRow,
  MatFooterRowDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  SiaAction,
  SiaActionFired,
  SiaActionsContainerComponent,
  SiaActionsService,
} from '@sia/actions';
import { AuthService } from '@sia/auth';
import {
  SiaCheckBoxComponent,
  SiaColorBoxComponent,
  SiaDateTimeBoxComponent,
  SiaNumberboxComponent,
  SiaSelectBoxComponent,
  SiaTextBoxComponent,
  SiaTimeBoxComponent,
} from '@sia/inputs';
import {
  BreakLinePipe,
  OutsideClickDirective,
  OverflowTooltipDirective,
  SafeHtmlPipe,
  SiaBaseScriptComponent,
  SiaChoiceDialogComponent,
  SiaClickStopPropagation,
  SiaColorContrastAutoDirective,
  SiaComponentConfigApi,
  SiaComponentConfigPerspectives,
  SiaComponentConfigService,
  SiaFormatNumberPipe,
  SiaGridAvatarComponent,
  SiaHttpService,
  SiaInitDirective,
  SiaLayoutService,
  SiaMenuService,
  SiaRouteData,
  SiaScrollBottomNotifyDirective,
  SiaSearchBoxComponent,
  SiaSessionParam,
  SiaSqlFilters,
  SiaTooltipDirective,
  SiaTranslatePipe,
  SiaWindowSize,
  YesNoDialogComponent,
  jsonDeepClone,
  notify,
} from '@sia/shared';
import { SiaTemplateRendererComponent } from '@sia/template';
import { it } from 'date-fns/locale/it';
import { Column, Workbook, Worksheet } from 'exceljs';
import saveAs from 'file-saver';
import { Guid } from 'guid-typescript';
import $ from 'jquery';
import markJs from 'mark.js';
import {
  EMPTY,
  Subject,
  Subscription,
  catchError,
  filter,
  firstValueFrom,
  from,
  map,
  switchMap,
  take,
  takeUntil,
  tap,
} from 'rxjs';
import { SiaGridApi } from '../../apis/sia-grid-api';
import { SaveGridViewDialogComponent } from '../../dialogs/save-grid-view-dialog/save-grid-view-dialog.component';
import { ResizeColumnDirective } from '../../directives/resize-columns.directive';
import { GridHttpParams } from '../../interfaces/grid-http-params';
import {
  GridTemplateVisibility,
  TemplateVisibility,
} from '../../interfaces/grid-template-visibility';
import { SiaGridColConfig } from '../../interfaces/sia-grid-col-config';
import { SiaGridColumnInstance } from '../../interfaces/sia-grid-column-instance';
import { Group, SiaGridConfig } from '../../interfaces/sia-grid-config';
import { SiaGridPageRequest } from '../../interfaces/sia-grid-page-request';
import {
  SiaGridSummary,
  SiaGridSummaryRequest,
} from '../../interfaces/sia-grid-summary-request';
import { SiaGridService } from '../../services/sia-grid.service';
@Component({
  selector: 'sia-mat-grid',
  templateUrl: './sia-mat-grid.component.html',
  styleUrls: ['./sia-mat-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    OverflowTooltipDirective,
    SiaTemplateRendererComponent,
    SiaColorContrastAutoDirective,
    SiaScrollBottomNotifyDirective,
    SiaColorBoxComponent,
    MatButton,
    MatIcon,
    MatTable,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatFooterRowDef,
    MatFooterRow,
    MatColumnDef,
    MatCellDef,
    SiaActionsContainerComponent,
    MatCell,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCheckbox,
    MatFooterCellDef,
    MatFooterCell,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatChipListbox,
    MatChip,
    ResizeColumnDirective,
    SiaTooltipDirective,
    SiaClickStopPropagation,
    MatMenuContent,
    SiaCheckBoxComponent,
    MatFormField,
    MatSelect,
    MatSelectTrigger,
    MatOption,
    MatInput,
    FormsModule,
    MatDatepickerToggle,
    MatSuffix,
    MatDateRangeInput,
    MatStartDate,
    MatEndDate,
    MatDateRangePicker,
    MatPaginator,
    SiaTranslatePipe,
    SafeHtmlPipe,
    SiaFormatNumberPipe,
    BreakLinePipe,
    MatDividerModule,
    MatButtonModule,
    MatBadgeModule,
    DragDropModule,
    CdkDropList,
    CdkDrag,
    SiaSearchBoxComponent,
    DatePipe,
    SiaDateTimeBoxComponent,
    SiaTimeBoxComponent,
    SiaNumberboxComponent,
    SiaTextBoxComponent,
    SiaGridAvatarComponent,
    SiaSelectBoxComponent,
    OutsideClickDirective,
    MatProgressSpinner,
    SiaInitDirective,
    MatTooltipModule,
  ],
  providers: [
    SiaGridApi,
    SiaGridService,
    SiaComponentConfigApi,
    SiaComponentConfigService,
    {
      provide: MAT_DATE_LOCALE,
      useValue: it,
    },
    provideDateFnsAdapter({
      parse: {
        dateInput: 'dd/MM/yyyy',
      },
      display: {
        dateInput: 'dd/MM/yyyy',
        monthYearLabel: 'MM yyyy',
        dateA11yLabel: 'dd/MM/yyyy HH:mm',
        monthYearA11yLabel: 'MMMM yyyy',
      },
    }),
  ],
  host: {
    '[attr.id]': 'dynamicId()',
  },
})
export class SiaMatGridComponent extends SiaBaseScriptComponent {
  /** Mappa timeouts pianificati (scheduleOnce) -> id: timeoutHandle */
  protected authService = inject(AuthService); // usate per chiamare impersonate
  #scheduledTimeouts: Record<string, any> = {};
  #lastGridId: string | undefined;
  #lastPageData: SiaRouteData | undefined;
  #paramsHardUpdatedSub?: Subscription;
  #lastSelectedGridView: SiaComponentConfigPerspectives | undefined;
  #configPerspective?: SiaComponentConfigPerspectives | null;
  #siaComponentConfigService = inject(SiaComponentConfigService);
  #siaActionsService = inject(SiaActionsService);
  #siaLayoutService = inject(SiaLayoutService);
  #siaGridService = inject(SiaGridService);
  #cdr = inject(ChangeDetectorRef);
  #menuService = inject(SiaMenuService);
  #httpService = inject(SiaHttpService);
  #host = inject(ElementRef);
  #ngZone: NgZone = inject(NgZone);
  #destroyRef = inject(DestroyRef);
  #destroy = new Subject<void>();
  #saveStyleParent: any[] = [];
  #summaryConf: SiaGridSummaryRequest = { componentId: '' };
  #pressingCtrl: boolean = false;
  #rowStyles: any = {};
  #privateTemplateVisibility?: GridTemplateVisibility;
  #privateTemplatePerspective?: SiaComponentConfigPerspectives | null;
  #timeouts: any[] = [];
  #requestId?: string;
  #currentVisibleInLineGroups: any[] = [];
  #perSelectedRows: any[] = [];
  #activeColumnsFilters: any[] = [];
  #viewVisibleColumns: {
    markController?: markJs;
    id: string;
    name: string;
    headerName: string;
    isActive?: boolean;
    colConfig: SiaGridColConfig;
    filterOperator?: string;
    filterValue?: any;
    additionalFilters?: {
      filterOperator?: string;
      filterValue?: any;
    }[];
    headerFilterValue?: string[];
    headerFilterDataSource?: {
      id: string;
      description: string;
      selected: boolean;
      orderIndex: number;
      disabled: boolean;
      doesModifyDataSet: boolean;
    }[];
    widthSetted?: boolean;
    visibleIndex?: number;
  }[] = [];
  #previousSort: string = '';
  #previousTake?: number;
  #previousSkip?: number;
  #gridGroups: any[] | undefined = [];
  #lastGroupReduced: any = {};
  #previousWindowSize: [number, number] = [0, 0];
  #applyFiltersTimeout: any;
  #rowStylesInProgress: Promise<string>[] = [];
  #markInstance?: markJs;
  #parentsGroupsToShow: any[] = [];
  #foreignKey: any;
  #filters: any[] = [];
  #sqlFilters: any[] = [];
  #subs: Subscription[] = [];
  #viewInitialized: boolean = false;
  #primaryKeys: string[] = [];
  #primaryKeysToIdentifyWithHashtag: string[] = [];
  #rowAdding: boolean = false;
  #editingRow: any = null;
  #stateSort?: { index: number; direction: string; id: string }[] = [];
  #spParams?: { name: string | undefined; value: any | undefined }[] = [];
  #multiGridFilters: any = {};
  #canLoadData?: boolean = true;
  #firstLoadData: boolean = true;
  #configurationProcessed: boolean = false;
  #loadDataParams: SiaGridPageRequest = {};
  #reducedGroups: any[] = [];
  #initialData?: any[];
  #sqlFiltersType = new SiaSqlFilters();
  #continuousLoadingIntervalId: any;
  #scriptCanContinue: boolean = true;
  #isStatusPageIndex: boolean = false;
  #currentFilterMenuTrigger?: MatMenuTrigger;
  #alreadyLoadingData: boolean = false;
  #firstAdditionalTitle: string | undefined = undefined;

  #columns = signal<SiaGridColumnInstance[]>([]);
  #lastRowClickedOnScript = signal<boolean>(false);
  #gridColumnsWidthSet = signal<boolean>(false);
  #lastRowClickedData = signal<any>(undefined);

  compact = signal<boolean>(false);
  hasFilterPanel = signal<boolean>(false);
  showColumnChooserSpinner = signal<boolean>(false);
  showHeaderFilterSpinner = signal<boolean>(false);
  dynamicId = signal<string>(Guid.create().toString());
  gridConfigurations = signal<SiaComponentConfigPerspectives[]>([]);
  lastRowClickedIndex = signal<number | undefined>(undefined);

  columnChooserColumns = signal<
    {
      id: string;
      description: string;
      selected: boolean | undefined;
      visibleIndex?: number;
    }[]
  >([]);
  dataSourceBuilt = signal<boolean>(false);
  columnsWithSet = signal<boolean>(false);
  numberGroups = signal<number[]>([]);
  showTemplate = signal<boolean>(false);
  groupByMenuEnabled = signal<boolean>(false);
  showSkeleton = signal<boolean>(false);
  showBodySkeleton = signal<boolean>(false);
  selectedGridView = signal<SiaComponentConfigPerspectives | undefined>(
    undefined,
  );
  gridViews = signal<SiaComponentConfigPerspectives[]>([]);
  columnChooserVisible = signal<boolean>(false);
  allowSelectAll = signal<boolean>(false);
  haveTotals = signal<boolean>(false);
  configuration = signal<SiaGridConfig>({ group: {} });
  dataSource = signal<any[]>([]);
  totalCount = signal<null | number | undefined>(null);
  styleSignals = signal<Record<string, { style: string; class: string }>>({});
  currentPageIndex = signal<number>(0);
  groupByChips = signal<SiaGridColumnInstance[]>([]);
  selectedRows = signal<SelectionModel<any> | undefined>(undefined);
  fullScreen = signal<boolean>(false);
  summaries = signal<any[]>([]);
  paginatorHeight = signal<number>(0);

  roundCorners = input<boolean>(false);
  hideHeaderFilters = input<boolean>(false);
  hideArrows = input<boolean | undefined>(false);
  showHeaderGrid = input<boolean | undefined>(false);
  showActions = input<boolean>(false);
  isMultiGrid = input<boolean>(false);
  allowCompact = input<boolean>(false);
  compactInput = input<boolean>(false);
  focusClickedRow = input<boolean>(false);
  allowViews = input<boolean>(true);
  multiGridFiltersInput = input<any>({});
  canLoadDataInput = input<boolean | undefined>(true);
  gridId = input<string | undefined>();
  pageData = model<SiaRouteData | undefined>();
  pageSize = model<number>(50);
  enableGlobalFilterPanel = model<boolean>(false);
  globalFilter = model<string | undefined>(undefined);

  rowClicked = output<any>();
  rowFocused = output<any>();
  selectedGridViewOutput = output<string>();

  @ViewChildren(MatSelect) matSelectBoxes?: MatSelect[];
  @ViewChildren(MatFormField) matFormFields?: MatFormField[];
  @ViewChild(MatTable, { static: false }) matTable?: MatTable<any>;
  @ViewChild(MatPaginator, { static: false }) matPaginator?: MatPaginator;
  @ViewChild('views') views?: any;
  @ViewChild('templateContainer', { static: false })
  templateContainer?: ElementRef<HTMLElement>;
  paginatorEl = viewChild<ElementRef<HTMLElement>>('paginator');

  @HostBinding('class.borders-visibles')
  borderVisible: boolean = false;
  @HostBinding('class.round-corners')
  get hostRoundCorners(): boolean {
    return this.roundCorners();
  }
  @HostBinding('class.row-alternation') rowAlternation: boolean = false;
  @HostBinding('class')
  get componentClass() {
    return this.gridId() ?? '';
  }
  @HostBinding('class.compact')
  get hostCompact(): boolean {
    return this.compactViewActive();
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.code == 'ControlLeft' || event.code == 'ControlRight') {
      // The Ctrl key is pressed
      this.#pressingCtrl = true;
    } else {
      // The Ctrl key is not pressed
    }
  }
  @HostListener('window:keyup', ['$event'])
  onKeyup(event: KeyboardEvent) {
    if (event.code == 'ControlLeft' || event.code == 'ControlRight') {
      // The Ctrl key is pressed
      this.#pressingCtrl = false;
    } else {
      // The Ctrl key is not pressed
    }
  }

  isAllSelected = computed(() => {
    if (!this.selectedRows()) return false;
    const numSelected = this.selectedRows()!.selected.length;

    return numSelected >= (this.totalCount() ?? 0);
  });
  headerValuesWithoutData = computed(() => {
    let valuesWithoutData: { [key: string]: any[] } = {};
    this.columns().forEach((col) => {
      valuesWithoutData[col.id] = (col?.headerFilterDataSource ?? []).filter(
        (item) => item.doesModifyDataSet === false,
      );
    });
    return valuesWithoutData;
  });
  headerValuesWithData = computed(() => {
    let valuesWithData: { [key: string]: any[] } = {};
    this.columns().forEach((col) => {
      valuesWithData[col.id] = (col?.headerFilterDataSource ?? []).filter(
        (item) => item.doesModifyDataSet === true,
      );
    });
    return valuesWithData;
  });
  columnsIds = computed(() => {
    this.#columns();
    this.configuration();
    this.focusClickedRow();
    let ids =
      this.#columns()
        ?.filter((x) => x.isActive)
        .map((x) => x.id ?? '') ?? [];
    if (this.configuration().selectionMode) {
      ids = ['__selection-column', ...ids];
    }
    if (this.configuration().rowEditingEnabled) {
      ids = [...ids, '__action-column'];
    }
    if (this.focusClickedRow() && !this.fullScreen()) {
      ids = ['__focus-row-column', ...ids];
    }
    for (let i = 0; i < this.numberGroups().length; i++) {
      ids.unshift('group' + i);
    }
    return ids;
  });
  filterColumnsIds = computed(() => {
    this.#columns();
    this.configuration();
    this.focusClickedRow();
    let ids =
      this.#columns()
        ?.filter((x) => x.isActive)
        .map((x) => (x.id ? x.id + '-filter' : '')) ?? [];

    if (this.configuration().rowEditingEnabled) {
      ids = [...ids, '__action-column'];
    }
    if (this.focusClickedRow() && !this.fullScreen()) {
      ids = ['__focus-row-column', ...ids];
    }
    for (let i = 0; i < this.numberGroups().length; i++) {
      ids.unshift('group' + i);
    }
    return ids;
  });
  columns = computed(() => {
    this.#columns();
    return this.#columns().filter((x) => x.isActive);
  });
  groupingColumns = computed(() => {
    return this.#columns().filter((x) => x.colConfig.allowGrouping);
  });
  compactViewActive = computed(() => {
    return (
      this.compact() &&
      this.#lastRowClickedData() != null &&
      this.lastRowClickedIndex() !== undefined &&
      this.lastRowClickedIndex() !== null
    );
  });
  actionsPageData = computed(() => {
    this.pageData();
    this.gridId();
    if (this.gridId()) {
      let actionsPageData = {
        ...this.pageData(),
        componentId: this.gridId(),
        mode: 'read',
      };
      return actionsPageData;
    }
    return undefined;
  });
  currentPageSize = computed(() => {
    this.#loadDataParams.take = this.pageSize();
    return this.pageSize();
  });

  #dataSourceEffect = effect(() => {
    this.dataSource();
    if (this.matTable) {
      this.matTable.dataSource = this.dataSource();
      try {
        this.matTable.renderRows();
      } catch {
        // Column defs might not yet be fully initialized; retry on next tick
        this.#scheduleOnce(0, 'retry-renderRows', () => {
          try {
            this.matTable?.renderRows();
          } catch {
            /* give up silently */
          }
        });
      }

      let matTable = document.getElementById(this.gridId() ?? '');
      if (!matTable) {
        return;
      }
    }
    this.#cdr.markForCheck();
  });
  #selectedGridViewEffect = effect(() => {
    this.selectedGridView();
    untracked(() => {
      if (this.selectedGridView()?.levelType == 'private') {
        this.selectedGridViewOutput.emit(
          this.selectedGridView()?.description ?? '',
        );
      }
      if (this.gridId() == this.pageData()?.componentId) {
        if (this.selectedGridView()?.levelType == 'private') {
          var additionalTitle =
            (this.#firstAdditionalTitle
              ? this.#firstAdditionalTitle + ' / '
              : '') + (this.selectedGridView()?.description ?? '');
          this.#siaLayoutService.showAdditionalTitle(
            additionalTitle,
            this.pageData()?.guid ?? '',
          );
        } else {
          this.#siaLayoutService.showAdditionalTitle(
            this.#firstAdditionalTitle ?? '',
            this.pageData()?.guid ?? '',
          );
        }
      }
      if (this.selectedGridView()?.id == this.#lastSelectedGridView?.id) {
        return;
      }

      this.siaBaseActionService.disableAction(
        this.gridId(),
        this.pageData()?.guid ?? '',
        'delete-perspective',
        this.selectedGridView()?.levelType != 'private',
      );

      if (this.#lastSelectedGridView) {
        this.#clearStatus();
        this.#resetProperties(false, false);
        this.loadConfiguration();
      }
      this.#lastSelectedGridView = this.selectedGridView();
    });
  });
  #compactEffect = effect(async () => {
    const value = this.compactInput();
    untracked(async () => {
      if (value === this.compact()) {
        return;
      }
      this.compact.set(value);
      this.#buildDataSource();
      await this.#resetColumnWidths();
    });
  });
  #multiGridFiltersEffect = effect(() => {
    const value = this.multiGridFiltersInput();
    if (JSON.stringify(this.#multiGridFilters) === JSON.stringify(value)) {
      return;
    }
    this.#multiGridFilters = value;
    this.#processConfigFilter().then(async () => {
      if (this.#configurationProcessed) {
        await this.loadData();
      }
    });
  });
  #canLoadDataEffect = effect(async () => {
    const value = this.canLoadDataInput();
    if (value === this.#canLoadData) {
      return;
    }
    this.#canLoadData = value;
    this.#firstLoadData = true;
    if (this.#canLoadData === false) {
      this.#initialData = [];
      this.dataSource.set([]);
      this.#editingRow = null;
      this.#loadDataParams.filter = '';
      this.#loadDataParams.sqlFilter = '';
      this.#lastRowClickedData.set(undefined);
      return;
    }
    await this.#processConfigFilter();
    if (this.#configurationProcessed) {
      this.showSkeleton.set(true);
      await this.loadData(true);
    }
  });
  #gridIdEffect = effect(() => {
    this.pageData();
    this.gridId();
    this.baseRouterPageData = this.pageData() ?? this.baseRouterPageData;
    if (
      this.#lastGridId === this.gridId() &&
      this.#lastPageData?.guid == this.pageData()?.guid
    ) {
      return;
    }
    if (this.gridId() == this.pageData()?.componentId) {
      this.#firstAdditionalTitle = this.layoutService.getAdditionalTitle(
        this.pageData()?.guid ?? '',
      );
    }
    if (this.#lastGridId && this.#lastPageData) {
      this.saveStatus(this.#lastGridId, this.#lastPageData.guid);
    }
    this.#configurationProcessed = false;
    if (this.#lastGridId != this.gridId()) {
      this.#lastGridId = this.gridId();
    }
    if (JSON.stringify(this.#lastPageData) != JSON.stringify(this.pageData())) {
      this.#lastPageData = this.pageData();
    }
    this.showSkeleton.set(true);
    this.selectedGridView.set(undefined);
    this.#loadDataParams.componentId = this.gridId();
    if (this.#scheduledTimeouts['reassignColumnsWidth'])
      clearTimeout(this.#scheduledTimeouts['reassignColumnsWidth']);
    if (this.#viewInitialized) {
      this.selectedGridView.set(undefined);
    }
    this.#paramsHardUpdatedSub?.unsubscribe();
    this.#cancelAllScheduledTimeouts();
    this.loadConfiguration();
    this.#loadViews();
  });

  #currentPageIndexEffect = effect(() => {
    this.currentPageIndex();
    this.pageSize();
    this.#loadDataParams.skip = this.currentPageIndex() * this.pageSize();
    if (this.#configurationProcessed) {
      this.showBodySkeleton.set(true);
      this.loadData();
    }
  });

  async toggleColumn(
    _column: { id: string; description: string; selected: boolean | undefined },
    selected: boolean | undefined,
  ) {
    if (_column.selected == selected) {
      return;
    }
    this.showColumnChooserSpinner.set(true);
    this.showSkeleton.set(true);
    this.#cdr.detectChanges();

    // lascia passare un macrotask + un frame prima di partire
    await new Promise<void>((resolve) => setTimeout(resolve, 0));
    await new Promise<void>((resolve) =>
      requestAnimationFrame(() => resolve()),
    );
    _column.selected = selected;
    this.#columns.set(
      this.#columns().map((c) =>
        c.id === _column.id ? { ...c, isActive: selected ?? false } : c,
      ),
    );
    await this.#resetColumnWidths(false);
    await this.#sortColumnChooser();
    await this.loadData(true);
    this.showColumnChooserSpinner.set(false);
  }

  #populateSiaOrderByParams() {
    let columnsToSort = this.#columns()
      .filter((x) => x.orderByDirection)
      .sort((a, b) => (a.sortIndex ?? 0) - (b.sortIndex ?? 0));
    if (!columnsToSort.length || columnsToSort.length == 0) {
      this.#loadDataParams.orderBy = [];
      return;
    }
    this.#loadDataParams.orderBy = [];
    if (this.configuration().group?.groupDataField) {
      this.#loadDataParams.orderBy.push({
        colId: this.configuration().group!.groupDataField!,
        order: 'asc',
      });
    }
    if (this.configuration().subGroups) {
      this.configuration().subGroups!.forEach((group) => {
        if (!this.#loadDataParams.orderBy) {
          return;
        }
        if (group.groupDataField) {
          this.#loadDataParams.orderBy.push({
            colId: group.groupDataField,
            order: 'asc',
          });
        }
      });
    }
    for (let index = 0; index < columnsToSort.length; index++) {
      const column = columnsToSort[index].colConfig.dataField ?? '';
      const order = columnsToSort[index].orderByDirection!;
      if (
        this.#loadDataParams.orderBy.findIndex((elem) => elem.colId == column) <
        0
      )
        this.#loadDataParams.orderBy.push({ colId: column, order: order });
    }
  }

  #setCssColumnsWidth(element: any, width: any) {
    let num = Number(width);
    let widthStyle = num ? width + 'px' : width;
    $('.' + this.gridId() + ' .mat-column-' + element.id)?.css(
      'width',
      widthStyle,
    );
    $('.' + this.gridId() + ' .mat-column-' + element.id + '-filter')?.css(
      'width',
      widthStyle,
    );
  }

  async #calcFilters() {
    let filters: any[] = [];
    let activeColumnsFilters: any[] = [];
    let allColumnsIndex = 0;
    let activeColumnsIndex = 0;
    let sessionUpdated = false;
    for (const col of this.#columns()) {
      col.colConfig.headerClass = undefined;
      if (
        !col ||
        ((col.filterValue == null ||
          (typeof col.filterValue == 'string' &&
            col.filterValue.trim() == '')) &&
          (!col.headerFilterValue || col.headerFilterValue.length == 0) &&
          (!col || !col.additionalFilters || col.additionalFilters.length == 0))
      ) {
        if (
          col.colConfig.filterSessionParam &&
          JSON.stringify(col.filterValue) !=
            JSON.stringify(
              this.getSessionValue(col.colConfig.filterSessionParam),
            )
        ) {
          this.siaSessionService.updateSessionParams(
            this.pageData()?.guid ?? null,
            [{ id: col.colConfig.filterSessionParam, value: col.filterValue }],
          );
          sessionUpdated = true;
        }
        continue;
      }
      let alreadyApplied = false;
      let activeAlreadyApplied = false;
      if (
        col.filterValue != null &&
        (typeof col.filterValue != 'string' || col.filterValue.trim() != '')
      ) {
        let filter = [];
        let activeFilter = [];
        if (col.colConfig.dataType == 'number') {
          if (!Array.isArray(col.filterValue)) {
            filter.push(col.id, col.filterOperator, +col.filterValue);
            if (col.isActive) {
              activeFilter.push(col.id, col.filterOperator, +col.filterValue);
            }
          } else {
            filter.push(col.id, col.filterOperator, col.filterValue);
            if (col.isActive) {
              activeFilter.push(col.id, col.filterOperator, col.filterValue);
            }
          }

          filters.push(filter);
          if (col.isActive) {
            activeColumnsFilters.push(activeFilter);
          }
        } else {
          if (
            (col.colConfig.dataType == 'date' ||
              col.colConfig.dataType == 'datetime') &&
            col.filterOperator != 'between' &&
            Array.isArray(col.filterValue) &&
            col.filterValue.length &&
            col.filterValue.length > 0
          ) {
            col.filterValue = col.filterValue[0];
          }
          if (col.filterValue != null && col.filterValue != undefined) {
            filter.push(col.id, col.filterOperator, col.filterValue);
            filters.push(filter);
            if (col.isActive) {
              activeFilter.push(col.id, col.filterOperator, col.filterValue);
              activeColumnsFilters.push(filter);
            }
          }
        }
        alreadyApplied = true;
        if (col.isActive) {
          activeAlreadyApplied = true;
        }
      }
      if (
        col.colConfig.filterSessionParam &&
        JSON.stringify(col.filterValue) !=
          JSON.stringify(this.getSessionValue(col.colConfig.filterSessionParam))
      ) {
        this.siaSessionService.updateSessionParams(
          this.pageData()?.guid ?? null,
          [{ id: col.colConfig.filterSessionParam, value: col.filterValue }],
        );
        sessionUpdated = true;
      }
      if (col.headerFilterValue && col.headerFilterValue.length > 0) {
        let filter = [];
        let activeFilter = [];

        if (alreadyApplied) {
          filters.push('and');
        }
        if (activeAlreadyApplied) {
          activeColumnsFilters.push('and');
        }

        filter.push(col.id, 'anyof', col.headerFilterValue);
        filters.push(filter);
        if (col.isActive) {
          activeFilter.push(col.id, 'anyof', col.headerFilterValue);
          activeColumnsFilters.push(activeFilter);
        }
        alreadyApplied = true;
        if (col.isActive) {
          activeAlreadyApplied = true;
        }
      }
      if (col.additionalFilters && col.additionalFilters.length > 0) {
        col.additionalFilters.forEach((additionalFilter) => {
          let filter = [];
          let activeFilter = [];

          if (alreadyApplied) {
            filters.push('and');
          }
          if (activeAlreadyApplied) {
            activeColumnsFilters.push('and');
          }
          filter.push(
            col.id,
            additionalFilter.filterOperator,
            additionalFilter.filterValue,
          );
          filters.push(filter);
          if (col.isActive) {
            activeFilter.push(
              col.id,
              additionalFilter.filterOperator,
              additionalFilter.filterValue,
            );
            activeColumnsFilters.push(activeFilter);
          }
          alreadyApplied = true;
          if (col.isActive) {
            activeAlreadyApplied = true;
          }
        });
      }
      allColumnsIndex++;
      if (col.isActive) {
        activeColumnsIndex++;
      }
    }
    if (sessionUpdated) {
      this.siaParamsAndPatternsService.notifyParamsUpdatedWithGuidFilterPanel(
        this.pageData()?.guid,
      );
    }
    var sqlFilters: string[] = [];
    let isFirst = true;
    var filtersPromises: Promise<any>[] = [];
    for (const sqlFilter of this.configuration().sqlPrefilters ?? []) {
      if (sqlFilter.valueScript) {
        filtersPromises.push(this.execScript(sqlFilter.valueScript));
      }
    }

    const results = await Promise.all(filtersPromises);
    for (let index = 0; index < results.length; index++) {
      let sqlWhere = results[index];
      if (sqlWhere) {
        if (!isFirst) {
          sqlFilters.push('and');
        } else {
          isFirst = false;
        }
        sqlFilters.push(sqlWhere);
      }
    }
    this.#filters = filters;
    this.#sqlFilters = sqlFilters;
    this.#activeColumnsFilters = activeColumnsFilters;
  }

  async #manageActionFired(action: SiaAction, element?: MatMenuTrigger) {
    const guid = this.pageData()?.guid ?? '';
    const compId = this.gridId() ?? this.pageData()?.componentId ?? '';

    switch (action.id) {
      case 'create':
        // converto la promise in Observable e la eseguo
        from(this.#manageGridAdding())
          .pipe(takeUntil(this.#destroy))
          .subscribe();
        break;

      case 'delete': {
        if (
          !this.selectedRows() ||
          !this.selectedRows()?.selected.length ||
          this.selectedRows()?.selected.length == 0
        ) {
          notify('Selezionare almeno una riga da eliminare', 2000, 'warning');
          return;
        }
        const dialogRef = this.dialog.open(YesNoDialogComponent, {
          width: '350px',
          data: { title: 'Vuoi eliminare i record selezionati ? ' },
        });

        // dialogRef.afterClosed() → scelta utente → estraggo le chiavi → chiamo massiveDelete → notifiche
        dialogRef
          .afterClosed()
          .pipe(
            takeUntil(this.#destroy),
            filter((result) => !!result),
            map(() => this.extractSelectedKeys()),
            switchMap((keys) =>
              from(
                this.#siaGridService.massiveDelete(
                  this.gridId()!,
                  this.configuration().massiveDeleteSPName!,
                  keys,
                ),
              ),
            ),
            tap(async (success) => {
              if (success) {
                notify('Eliminati con successo', 2000, 'success');
              } else {
                notify("Errore durante l'eliminazione", 2000, 'error');
              }
              this.siaRouterService.notifyPageMode(guid, 'read');
              this.configuration.update((config) => {
                return { ...config, selectionMode: undefined };
              });
              this.showSkeleton.set(true);
              await new Promise<void>((resolve) => setTimeout(resolve, 0));
              await new Promise<void>((resolve) =>
                requestAnimationFrame(() => resolve()),
              );
              await this.#resetColumnWidths(false);
            }),
          )
          .subscribe();
        break;
      }

      case 'update':
        if (
          !this.selectedRows() ||
          !this.selectedRows()?.selected.length ||
          this.selectedRows()?.selected.length == 0
        ) {
          notify(
            'Selezionare più di un record per poter aggiornare',
            1500,
            'error',
          );
          return;
        }
        const sel = JSON.parse(this.selectedRows()?.selected[0] as string);
        const crud = sel['__massiveoperationcrud'];
        if (!crud) {
          notify(
            "Non è stato possibile recuperare la pagina per l'aggiornamento",
            1500,
            'error',
          );
          return;
        }
        const keys = this.extractSelectedKeys();
        this.siaRouterService.navigateMenuWithParams(
          'popup^' + crud,
          [
            { id: 'selected-keys', value: keys },
            { id: 'massive-update', value: true },
            { id: 'bar-type', value: 'row-warn' },
            {
              id: 'bar-message',
              value:
                this.i18nService.translate('Stai aggiornando ') +
                keys.length +
                this.i18nService.translate(' record'),
            },
          ],
          'update',
        );
        this.siaRouterService.notifyPageMode(guid, 'read');
        this.configuration.update((config) => {
          return { ...config, selectionMode: undefined };
        });
        this.showSkeleton.set(true);
        await new Promise<void>((resolve) => setTimeout(resolve, 0));
        await new Promise<void>((resolve) =>
          requestAnimationFrame(() => resolve()),
        );
        await this.#resetColumnWidths(false);
        break;

      case 'cancel':
        this.siaRouterService.notifyPageMode(guid, 'read');
        this.configuration.update((config) => {
          return { ...config, selectionMode: undefined };
        });
        this.#processSelectionMode();
        this.showSkeleton.set(true);
        await new Promise<void>((resolve) => setTimeout(resolve, 0));
        await new Promise<void>((resolve) =>
          requestAnimationFrame(() => resolve()),
        );
        await this.#resetColumnWidths(false);
        break;

      case 'massive-update':
      case 'massive-delete':
        this.allowSelectAll.set(action.id === 'massive-delete');
        this.siaBaseActionService.handleAction(
          compId,
          guid,
          'delete',
          action.id === 'massive-delete',
        );
        this.siaBaseActionService.handleAction(
          compId,
          guid,
          'update',
          action.id !== 'massive-delete',
        );
        this.siaRouterService.notifyPageMode(guid, action.modeAfterFire);
        this.configuration.update((config) => {
          return { ...config, selectionMode: 'multiple' };
        });
        this.#processSelectionMode();
        this.showSkeleton.set(true);
        await new Promise<void>((resolve) => setTimeout(resolve, 0));
        await new Promise<void>((resolve) =>
          requestAnimationFrame(() => resolve()),
        );
        await this.#resetColumnWidths(false);
        this.showSkeleton.set(false);
        break;

      case 'configure':
        this.siaRouterService.navigateMenuWithParams('mat-grid-config', [
          { id: 'gridId', value: this.gridId() },
        ]);
        break;

      case 'export-excel':
        // se exportTOExcel() ritorna Promise, puoi convertirla in from(...)
        this.#exportTOExcel();
        break;

      case 'column-chooser':
        this.toggleColumnChooserVisibility();
        break;

      case 'delete-perspective':
        this.deleteCurrentView();
        break;

      case 'save-perspective':
        from(this.saveCurrentViewAsPerspective())
          .pipe(takeUntil(this.#destroy))
          .subscribe();
        break;

      case 'perspective-list':
        if (this.views && element?.menu !== this.views) {
          element!.menu = this.views; // prima
        }

        if (!element?.menuOpen) {
          element?.openMenu(); // solo open
        }
        break;

      case 'fullscreen':
        this.fullScreen.set(true);
        this.siaBaseActionService.handleAction(
          compId,
          guid,
          'fullscreen',
          false,
        );
        this.siaBaseActionService.handleAction(
          compId,
          guid,
          'exit-fullscreen',
          true,
        );
        this.setGridFullScreen($('#siaTableFullScreen' + this.gridId())[0]);
        this.#timeouts.push(
          setTimeout(() => {
            this.setEmptyRowHeight();
          }, 200),
        );
        break;

      case 'exit-fullscreen':
        this.fullScreen.set(false);
        this.siaBaseActionService.handleAction(
          compId,
          guid,
          'fullscreen',
          true,
        );
        this.siaBaseActionService.handleAction(
          compId,
          guid,
          'exit-fullscreen',
          false,
        );
        this.exitFullscreenMode();
        break;

      case 'toggle-template':
        from(
          (async () => {
            this.showSkeleton.set(true);
            const device =
              this.siaSizeDetector.currentSize.deviceType?.toLowerCase() ||
              'desktop';
            const selId = this.selectedGridView()?.id!;
            this.showTemplate.update((value) => !value);

            // Assicuro le strutture base
            if (!this.#privateTemplateVisibility)
              this.#privateTemplateVisibility = {} as GridTemplateVisibility;
            if (!this.#privateTemplateVisibility[selId]) {
              this.#privateTemplateVisibility[selId] = {};
            }
            const selVisibility = this.#privateTemplateVisibility[
              selId
            ] as TemplateVisibility;
            // Aggiorno la visibilità per device
            selVisibility[device as keyof TemplateVisibility] =
              this.showTemplate();

            // Assicuro la perspective
            if (!this.#privateTemplatePerspective) {
              this.#privateTemplatePerspective = {
                componentId: this.gridId()!,
                configType: 'grid-template-view',
                jsonConfig: '',
                isPrivateAndSingle: true,
                isPrivate: true,
                userId: this.user?.id,
                description: 'template visibility',
                defaultMode: 'A',
              };
            }
            // Aggiorno JSON e flags (flags duplicate prima in entrambi i rami)
            this.#privateTemplatePerspective.jsonConfig = JSON.stringify(
              this.#privateTemplateVisibility,
            );
            this.#privateTemplatePerspective.isPrivateAndSingle = true;
            this.#privateTemplatePerspective.isPrivate = true;
            const ok =
              await this.#siaComponentConfigService.setComponentPerspective(
                this.#privateTemplatePerspective,
              );
            notify(
              ok
                ? 'Vista aggiornata con successo'
                : 'Impossibile aggiornare la vista',
              1500,
              ok ? 'success' : 'error',
            );
            await this.#processTemplateVisibility();
            return this.#loadViews();
          })(),
        )
          .pipe(
            takeUntil(this.#destroy),
            switchMap((ok) => {
              this.showBodySkeleton.set(true);
              if (!this.showTemplate()) {
                this.resetColumnWidths();
              }
              return from(this.loadData(true));
            }),
          )
          .subscribe();
        break;

      case 'refresh':
        this.showBodySkeleton.set(true);
        this.loadData(true);
        break;
    }
  }

  async setGridFullScreen(element: HTMLElement) {
    let nodes = [];
    nodes.push(element);
    while (element.parentNode) {
      nodes.unshift(element.parentNode);
      if (element.getAttribute('style')) {
        this.#saveStyleParent.push({
          element: element,
          style: element.getAttribute('style'),
        });
        element.setAttribute('style', 'display:block; z-index:109');
        element.classList.add('no-transform');

        element.classList.remove('overflow-hidden');
      }
      element = element.parentNode as HTMLElement;
    }
    await this.reassignColumnsWidth();
  }

  async exitFullscreenMode() {
    this.#restoreParentStyles();
    $('.' + this.gridId() + ' .sia-empty-row').attr(
      'style',
      'height: ' + 0 + 'px !important',
    );
    await this.reassignColumnsWidth();
  }

  #restoreParentStyles() {
    this.#saveStyleParent.forEach(
      (parent: { element: HTMLElement; style: string }) => {
        parent.element.setAttribute('style', parent.style);
        parent.element.classList.remove('no-transform');
      },
    );
    this.#saveStyleParent = [];
  }

  toggleColumnChooserVisibility() {
    this.columnChooserVisible.set(!this.columnChooserVisible());
    let divSiaColumnChooser = $(`#${this.dynamicId()} .sia-side-panel`);
    divSiaColumnChooser.toggleClass('visible');
  }

  async #manageGridAdding() {
    if (!this.configuration().addingType) {
      this.notify(
        this.i18nService.translate('La griglia non permette aggiunte'),
        1500,
        'warning',
      );
    }
    switch (this.configuration().addingType) {
      case 'choice':
        let choices = {
          title: this.configuration().addingChoisesTitle,
          description: this.configuration().addingChoicesDescription,
          items: this.configuration().addingChoisesItems,
        };
        let dialogRef = this.dialog.open(SiaChoiceDialogComponent, {
          width: '250px',
          data: choices,
        });
        let s0 = dialogRef.afterClosed().subscribe(async (script: any) => {
          if (script) {
            await this.execScript(script);
          }
        });
        this.#subs.push(s0);
        break;
      case 'row':
        // Check if a row is already being edited or added
        if (this.#editingRow) {
          // Highlight the existing editing/adding row
          this.scrollGrid(this.#editingRow);
          return;
        }
        const newRow = {
          __editing: true,
          __isAdding: true,
          __tempId: Date.now() + Math.random(), // Unique temp ID for tracking
        };
        this.#editingRow = newRow;
        this.#rowAdding = true;
        this.#buildDataSource();
        break;
      case 'script':
        if (this.configuration().addingActionScript) {
          await this.execScript(this.configuration().addingActionScript!);
        }
        break;
      default:
        break;
    }
  }

  async #resetProperties(
    configurationFoundInSession: boolean,
    pageFoundInSession: boolean,
  ) {
    this.#gridColumnsWidthSet.set(false);
    if (!this.selectedGridView()) {
      if (!pageFoundInSession) {
        this.currentPageIndex.set(0);
        this.pageSize.set(50);
        this.lastRowClickedIndex.set(undefined);
      }
    }
    if (!configurationFoundInSession) {
      this.pageSize.set(50);
      this.configuration.set({ group: {} });
      if (!pageFoundInSession) {
        this.#columns.set([]);
        this.columnChooserColumns.update(() => []);
      }
    }
    // Reset width settings for all existing columns
    this.#columns()?.forEach((col) => {
      col.widthSetted = false;
    });
    this.#stateSort = undefined;
    this.#filters = [];

    this.#viewVisibleColumns = [];
    this.groupByChips.set([]);
    this.#reducedGroups = [];
    if (this.matTable) {
      this.matTable.dataSource = [];
    }
    this.dataSource.set([]);
    this.#gridGroups = [];
    this.numberGroups.set([]);
    if (!pageFoundInSession) {
      this.#lastRowClickedData.set(undefined);
    }
    this.haveTotals.set(false);
    this.#initialData = [];
    // this.data = [];
    this.totalCount.set(null);
    this.#loadDataParams.requireTotalCount = true;
    this.#loadDataParams.filter = '';
    this.#loadDataParams.orderBy = [];
    this.#summaryConf = { componentId: '' };
    this.#rowStyles = {};
    this.#rowStylesInProgress = [];
    // Reset column width tracking to ensure proper width assignment
    this.columnsWithSet.set(false);
    this.dataSourceBuilt.set(false);
  }

  #mapCommonSettings(
    configuration: SiaGridConfig,
    configurationFoundInSession: boolean,
  ) {
    this.haveTotals.set(
      this.configuration().cols?.findIndex((x) => x.summaryColEnable) != -1,
    );
    this.#primaryKeys =
      this.configuration()
        .cols?.filter((x) => x.primaryKey)
        .map((x) => x.dataField ?? '') ?? [];
    this.#primaryKeysToIdentifyWithHashtag =
      this.configuration()
        .cols?.filter((x) => x.primaryKey && !x.hidePrimaryKeyIdentifier)
        .map((x) => x.dataField ?? '') ?? [];
    this.borderVisible = configuration.showBorders ?? false;
    if (!configurationFoundInSession) {
      this.pageSize.set(configuration.pageSize || 50);
    }
    this.rowAlternation = configuration.rowAlternationEnabled ?? false;
    this.#summaryConf.componentId = this.gridId() ?? '';
    this.#summaryConf.summaries =
      configuration.cols
        ?.filter((x) => x.summaryColEnable)
        ?.map((x) => {
          let summary: SiaGridSummary = {
            configurationColumnId: x.dataField ?? '',
            colId: x.summaryDataField
              ? x.summaryDataField
              : (x.dataField ?? ''),
            operator: x.summaryType ?? '',
            summaryIndex: 0,
            colname:
              this.#columns().find((col) => col.id == x.dataField)
                ?.headerName ?? ' ',
            format: x.summaryDisplayFormat,
          };
          return summary;
        }) ?? [];
  }

  async setValueSpParams() {
    this.#spParams = [];
    const paramPromises =
      this.configuration().params?.map(async (p) => {
        const valueScript = await this.execScript(p.script as string);
        return { name: p.name, value: valueScript };
      }) ?? [];
    this.#spParams = await Promise.all(paramPromises);
  }
  protected async loadData(force: boolean = false, concat: boolean = false) {
    if (this.#alreadyLoadingData) {
      return;
    }
    if (this.#canLoadData === false) {
      this.#initialData = [];
      this.dataSource.set([]);
      this.#editingRow = null;
      this.#filters = [];
      return;
    }
    if (
      !this.gridId() ||
      !this.configuration().cols ||
      this.configuration().cols!.length === 0
    ) {
      return;
    }
    try {
      this.#alreadyLoadingData = true;
      await this.#calcFilters();
      this.#populateSiaOrderByParams();
      this.#loadDataParams.orderBy = this.#loadDataParams.orderBy ?? [];
      if (this.configuration().group?.groupDataField) {
        let previousIndex = this.#loadDataParams.orderBy.findIndex(
          (x: any) => x.colId == this.configuration().group?.groupDataField,
        );
        let sort = 'asc';
        if (previousIndex != -1) {
          sort = this.#loadDataParams.orderBy.splice(previousIndex, 1)[0].order;
        }
        this.#loadDataParams.orderBy.unshift({
          colId: this.configuration().group?.groupDataField!,
          order: sort,
        });
      }
      this.#loadDataParams.columns = this.#columns()
        .filter((x) => x.isActive && !x.colConfig.alwaysLoad)
        .map((x) => x.id);
      this.#loadDataParams.columns = [
        ...this.#loadDataParams.columns,
        ...(this.configuration()
          .cols?.filter((x) => x.alwaysLoad)
          .map((x) => x.dataField ?? '') ?? []),
      ];
      if (this.configuration().group?.groupDataField) {
        this.#loadDataParams.columns.push(
          this.configuration().group?.groupDataField!,
        );
      }
      let jsonFilter = JSON.stringify(this.#filters);
      let jsonSqlFilter = JSON.stringify(this.#sqlFilters);
      let filterChanged =
        this.#loadDataParams.filter != jsonFilter ||
        this.#loadDataParams.globalFilter != this.globalFilter();

      filterChanged = filterChanged
        ? true
        : jsonSqlFilter != this.#loadDataParams.sqlFilter;
      let groups: {
        columnName: string;
        groupsId: string[];
        ColumnNameSubGroup: string[];
      } = {
        columnName: this.configuration().group?.groupDataField ?? '',
        groupsId: [],
        ColumnNameSubGroup:
          this.configuration().subGroups?.map((x) => x.groupDataField ?? '') ??
          [],
      };

      this.#reducedGroups.forEach((group) => {
        if (group.value) {
          groups.groupsId.push(JSON.stringify(group.value));
        }
      });

      this.#loadDataParams.filter = jsonFilter;
      this.#loadDataParams.sqlFilter = jsonSqlFilter;
      this.#loadDataParams.foreignKey = this.#foreignKey;
      this.#loadDataParams.globalFilter = this.globalFilter();
      this.#loadDataParams.hiddenGroups = groups;
      filterChanged = filterChanged
        ? true
        : this.#previousSort != JSON.stringify(this.#loadDataParams.orderBy) ||
          JSON.stringify(this.#loadDataParams.spParams) !=
            JSON.stringify(this.#spParams);
      this.#loadDataParams.spParams = this.#spParams;
      if (
        !filterChanged &&
        !force &&
        this.#previousTake == this.#loadDataParams.take &&
        this.#previousSkip == this.#loadDataParams.skip
      ) {
        // nothing will change in the grid, but filters (global/column)
        // might have been modified – make sure any existing highlights
        // are updated immediately.  this also handles the case where
        // the filter text is typed but the resulting dataset stays
        // identical (common with template mode).
        this.markOnRowStyleChange();
        return;
      }

      if (this.#requestId) {
        await this.#httpService.cancelRequest(
          'grid-core/cancel',
          this.#requestId,
        );
        this.#requestId = undefined;
      }
      this.#requestId = Guid.create().toString();
      this.#loadDataParams.requestId = this.#requestId;
      this.#previousSkip = this.#loadDataParams.skip;
      this.#previousTake = this.#loadDataParams.take;
      this.#previousSort = JSON.stringify(this.#loadDataParams.orderBy);

      if (filterChanged) {
        this.#loadDataParams.requireTotalCount = true;
        if (!this.#isStatusPageIndex) {
          this.currentPageIndex.set(0);
        }
        this.selectedRows.set(undefined);
      } else {
        this.#loadDataParams.requireTotalCount = false;
      }
      if (this.showTemplate() && !concat) {
        this.#loadDataParams.skip = 0;
        this.#loadDataParams.take =
          this.currentPageIndex() * this.currentPageSize() +
          this.currentPageSize();
      } else {
        this.#loadDataParams.take = this.currentPageSize();
      }
      this.#loadDataParams.requireTotalCount = true;
      // Load data from server (compact mode filtering is handled client-side in buildDataSource)
      let dataSource = await this.#siaGridService.loadData(
        this.#loadDataParams,
      );

      await this.#processPathImages(dataSource);

      this.#gridGroups = dataSource?.groups;
      if (this.#gridGroups && this.#gridGroups.length > 0) {
        this.numberGroups.set([]);
        let groupCount: number[] = [];
        for (let i = 0; i < Object.keys(this.#gridGroups[0]).length - 1; i++) {
          groupCount.push(i);
        }
        this.numberGroups.set(groupCount);
      } else {
        // Ensure no leftover group columns when the loaded grid has no groups
        this.numberGroups.set([]);
      }
      // this.reassignColumnsWidth();
      // this.gridGroups?.map((x) => (x.groupId = JSON.stringify(x.groupId)));
      this.#isStatusPageIndex = false;
      if (
        (force || filterChanged) &&
        this.#summaryConf.summaries &&
        this.#summaryConf.summaries.length > 0 &&
        !this.compactViewActive()
      ) {
        this.#summaryConf.filter = this.#loadDataParams.filter;
        this.#summaryConf.sqlFilter = this.#loadDataParams.sqlFilter;
        this.#summaryConf.foreignKey = this.#loadDataParams.foreignKey;
        this.#summaryConf.columns = this.#loadDataParams.columns;
        this.#summaryConf.globalFilter = this.#loadDataParams.globalFilter;
        this.#summaryConf.selectSpName = this.#loadDataParams.selectSpName;
        this.#scheduleOnce(300, 'summary', async () => {
          let resSummaries = await this.#siaGridService.loadSummary(
            this.#summaryConf,
          );
          if (this.#summaryConf.summaries) {
            for (let index = 0; index < resSummaries.length; index++) {
              const element = resSummaries[index];
              if (this.#summaryConf.summaries[index]) {
                this.#summaryConf.summaries[index].result = element.result;
                this.#summaryConf.summaries![index].colname =
                  this.#columns().find(
                    (col) =>
                      col.id ==
                      this.#summaryConf.summaries![index].configurationColumnId,
                  )?.headerName ?? ' ';
              }
            }
            this.#summaryConf.summaries!.forEach((element) => {
              this.#columns.update((cols) => {
                const col = cols.find(
                  (x) => x.id === element.configurationColumnId,
                );
                if (col?.colConfig) {
                  col.colConfig.summaryValue = element.result;
                  col.colConfig.summaryScriptApplied = false;
                  this.processSummaryScript(col?.colConfig);
                }

                return [...cols]; // nuova reference → scatta il render
              });
            });
          }
          this.summaries.set([...(this.#summaryConf.summaries || [])]);
        });
      } else {
        this.summaries.set([...(this.#summaryConf.summaries || [])]);
      }
      if (this.showTemplate() && concat) {
        this.#initialData = this.#initialData!.concat(dataSource.items);
      } else if (!concat && this.showTemplate()) {
        this.#initialData = [];
        this.#initialData = dataSource?.items;
        this.#lastGroupReduced = undefined;
      } else {
        this.#initialData = dataSource?.items;
      }
      this.totalCount.set(
        this.#loadDataParams.requireTotalCount
          ? dataSource?.totalCount
          : this.totalCount(),
      );

      if (
        this.#lastRowClickedData() &&
        !this.#firstLoadData &&
        (filterChanged ||
          this.#previousTake != this.#loadDataParams.take ||
          this.#previousSkip != this.#loadDataParams.skip)
      ) {
        this.toggleCompactMode(
          this.#lastRowClickedData(),
          this.lastRowClickedIndex(),
          true,
        );

        this.saveStatus();
        // If row exists, don't change anything
      }

      // Special case: if only one row and it's different from last clicked
      if (
        this.#initialData &&
        this.#initialData?.length == 1 &&
        JSON.stringify(this.#initialData[0]) !=
          JSON.stringify(this.#lastRowClickedData()) &&
        this.isMultiGrid() &&
        this.allowCompact() &&
        this.#firstLoadData &&
        (this.lastRowClickedIndex() != 0 || !this.compactViewActive())
      ) {
        await this.toggleRowFromIndex(0);
      }

      await this.#buildDataSource();
      await this.reassignColumnsWidth();
      // after the grid has been rendered/adjusted we also request
      // a final highlight update in case filter text changed while the
      // data was being fetched.  this is harmless if nothing changed.
      this.markOnRowStyleChange();
      this.#firstLoadData = false;
    } finally {
      this.#requestId = undefined;
      this.#scheduleOnce(100, 'skeletonFalse', () => {
        this.showSkeleton.set(false);
        this.showBodySkeleton.set(false);
      });
      this.#alreadyLoadingData = false;
    }
  }

  async #processPathImages(dataSource: any): Promise<void> {
    const imageColumns = this.#getImageColumnsRequiringProcessing();

    if (!imageColumns.length || !dataSource.items?.length) {
      return;
    }

    const tasks = dataSource.items.flatMap((item: any) =>
      imageColumns.map((col) => this.#convertImagePathToUrl(item, col)),
    );

    await Promise.all(tasks);
  }

  #getImageColumnsRequiringProcessing(): Array<{
    field: string;
    isRelative: boolean;
  }> {
    return (
      this.configuration()
        .cols?.filter(
          (col) =>
            col.dataType === 'image' &&
            col.imageSourceType === 'path' &&
            (col.alwaysLoad || col.visible),
        )
        ?.map((col) => ({
          field: col.dataField ?? '',
          isRelative: col.isRelativePath ?? true,
        }))
        .filter(
          (col): col is { field: string; isRelative: boolean } => !!col.field,
        ) ?? []
    );
  }

  async #convertImagePathToUrl(
    item: any,
    column: { field: string; isRelative: boolean },
  ): Promise<void> {
    if (!item[column.field]) {
      return;
    }

    try {
      const blob = await this.fileService.getBlob(
        item[column.field],
        column.isRelative,
      );
      const url = URL.createObjectURL(blob);
      item[column.field] = url;
      this.sanitizer.bypassSecurityTrustUrl(url);
    } catch (error) {
      console.warn(
        `Impossibile caricare immagine per campo ${column.field}`,
        error,
      );
    }
  }

  #getDefaultFilterType(dataType: string | undefined): string {
    switch (dataType) {
      case 'string':
        return this.#sqlFiltersType.stringFilters[0].id;
      case 'number':
        return this.#sqlFiltersType.numberFilters[0].id;
      case 'date':
      case 'time':
      case 'datetime':
        return this.#sqlFiltersType.dateFilters[0].id;
      default:
        return this.#sqlFiltersType.allFilters[0].id;
    }
  }
  async #orderColumns(configurationColumns: SiaGridConfig) {
    // 1) Clone the config and ensure we have an array of cols
    const configuration = jsonDeepClone(configurationColumns) as SiaGridConfig;
    const cols: SiaGridColConfig[] = configuration.cols ?? [];

    // 2) If a saved view is active, apply its visibleIndex to each col config
    if (this.selectedGridView()) {
      this.#viewVisibleColumns.forEach((vc) => {
        const colCfg = cols.find(
          (c: SiaGridColConfig) => c.dataField === vc.id,
        );
        if (colCfg) {
          colCfg.visibleIndex = vc.visibleIndex;
        }
      });
    }

    // 3) Sort the configuration by visibleIndex
    configuration.cols = cols
      .slice()
      .sort((a: SiaGridColConfig, b: SiaGridColConfig) => {
        const aIdx = a.visibleIndex ?? -Infinity;
        const bIdx = b.visibleIndex ?? -Infinity;
        return aIdx - bIdx;
      });

    // 4) Preserve any existing orderBy settings before we rebuild _columns
    const prevOrder = this.#columns()
      .filter((col) => !!col.orderByDirection)
      .sort((a, b) => a.sortIndex! - b.sortIndex!)
      .map((col) => ({
        id: col.id,
        dir: col.orderByDirection!,
        idx: col.sortIndex!,
      }));

    // 5) Reset the runtime columns array
    this.#columns.set([]);

    // 6) Build each column
    for (const colCfg of configuration.cols) {
      const caption = colCfg.captionScript
        ? await this.execScript(colCfg.captionScript)
        : (colCfg.caption ?? '');

      colCfg.caption = caption;
      if (!colCfg.dataField) {
        colCfg.dataField = Guid.create().toString();
      }

      // Find matching view settings
      const viewCol = this.#viewVisibleColumns.find(
        (vc) => vc.id === colCfg.dataField,
      );

      // Build the instance
      const instance: SiaGridColumnInstance = {
        id: colCfg.dataField!,
        name: caption,
        headerName: caption,
        isActive: viewCol?.isActive ?? colCfg.visible ?? false,
        visibleIndex: viewCol?.visibleIndex ?? colCfg.visibleIndex,
        filterOperator:
          viewCol?.filterOperator ??
          this.#getDefaultFilterType(colCfg.dataType),
        filterValue: viewCol?.filterValue,
        headerFilterValue: viewCol?.headerFilterValue,
        headerFilterDataSource: viewCol?.headerFilterDataSource,
        colConfig: jsonDeepClone(colCfg),
        orderByDirection: undefined,
        sortIndex: undefined,
        dataType: colCfg.dataType || '',
      };

      // Width settings
      if (viewCol?.colConfig.width) {
        instance.colConfig.width = viewCol.colConfig.width;
      } else if (!instance.colConfig.width && !instance.colConfig.minWidth) {
        instance.colConfig.minWidth = '200';
      }

      // Reapply sorting if present
      const ord = prevOrder.find((o) => o.id === instance.id);
      if (ord) {
        instance.orderByDirection = ord.dir;
        instance.sortIndex = ord.idx;
      }
      this.#columns.set([...this.#columns(), instance]);
    }
    // 7) Sort and reassign widths
    this.#sortColumns();
    if (this.dataSourceBuilt()) {
      this.#scheduleOnce(100, 'orderColumns-width-reassign', async () => {
        await this.reassignColumnsWidth();
      });
    }
  }

  #configureColumnChooser() {
    this.columnChooserColumns.set(
      this.#columns()
        .filter((x) => x.colConfig.showInColumnChooser || x.colConfig.visible)
        .map((x) => ({
          id: x.id,
          description: (x.name ?? '').trim(),
          selected: x.isActive,
        }))
        .filter((x) => x.description.length > 0), // <-- QUI: non entrano proprio
    );
  }

  #sortColumns() {
    const fallback = Number.MIN_SAFE_INTEGER; // undefined in testa
    this.#columns.update(() =>
      (this.#columns() ?? []).slice().sort((a, z) => {
        const aIndex = a.visibleIndex ?? fallback;
        const zIndex = z.visibleIndex ?? fallback;
        return aIndex - zIndex;
      }),
    );
  }

  deleteRow(rowData: any) {
    // 1) Apro il dialog come Observable
    const dialogRef = this.dialog.open(YesNoDialogComponent, {
      data: {
        title: 'Sicuro di voler eliminare la riga?',
        negativeMeaning: true,
      },
    });

    from(dialogRef.afterClosed())
      .pipe(
        // 2) Se non confermato o non ho gridId, esco
        takeUntil(this.#destroy),
        filter((confirmed) => !!confirmed),
        filter(() => !!this.gridId()),

        // 3) Preparo l'oggetto chiavi
        map(() => {
          const keysData: Record<string, any> = {};
          this.#primaryKeys.forEach((key) => (keysData[key] = rowData[key]));
          return keysData;
        }),

        // 4) Chiamo deleteRow sul service
        switchMap((keysData) =>
          this.#siaGridService.deleteRow(this.gridId()!, keysData),
        ),

        // 5) Notifico e ricarico se ok
        tap(async (success) => {
          if (success) {
            // Clear editing row if this was the one being edited
            const rowPrimaryKey = rowData['__primary-key'];
            if (
              this.#editingRow &&
              this.#editingRow['__primary-key'] === rowPrimaryKey
            ) {
              this.#editingRow = null;
            }

            this.notify('Riga eliminata con successo', 1500, 'success');
            if (this.#configurationProcessed) {
              await this.loadData();
            }
          } else {
            this.notify('Impossibile eliminare la riga', 1500, 'error');
          }
        }),
      )
      .subscribe();
  }
  editRow(rowData: any) {
    // Check if another row is already being edited or added
    if (this.#editingRow) {
      const isSameRow =
        this.#editingRow.__tempId === rowData.__tempId ||
        (this.#editingRow['__primary-key'] &&
          this.#editingRow['__primary-key'] === rowData['__primary-key']);

      if (!isSameRow) {
        // Highlight the existing editing row
        this.scrollGrid(this.#editingRow);
        return;
      }
    }

    rowData['__editing'] = true;
    rowData['__isAdding'] = false;
    this.#rowAdding = false;

    // Store reference to the single editing row
    this.#editingRow = rowData;
  }

  declineChanges(rowData: any) {
    rowData['__editing'] = false;

    // Clear the single editing row if it matches
    if (
      this.#editingRow &&
      (this.#editingRow.__tempId === rowData.__tempId ||
        (this.#editingRow['__primary-key'] &&
          this.#editingRow['__primary-key'] === rowData['__primary-key']))
    ) {
      this.#editingRow = null;
    }

    this.#buildDataSource();
  }

  async loadConfiguration() {
    if (!this.gridId()) {
      return;
    }
    let [configurationFoundInSession, pageFoundInSession] = [false, false];
    if (!this.selectedGridView()) {
      [configurationFoundInSession, pageFoundInSession] =
        await this.#getStatus();
    }
    this.#resetProperties(configurationFoundInSession, pageFoundInSession);
    if (!configurationFoundInSession) {
      let userPerspective: SiaComponentConfigPerspectives | null = null;

      if (this.selectedGridView()?.id) {
        const retrieved =
          (await this.#siaComponentConfigService.getPerspective(
            this.selectedGridView()!.id!,
          )) ?? null;

        if (this.selectedGridView()?.levelType === 'private') {
          userPerspective = retrieved;
          const selectedConfigurationId =
            this.#extractSelectedConfigurationId(userPerspective);

          this.#configPerspective = selectedConfigurationId
            ? await this.#siaComponentConfigService.getPerspective(
                selectedConfigurationId,
              )
            : null;
        } else {
          this.#configPerspective = retrieved;
        }
      } else {
        userPerspective =
          (await this.#siaComponentConfigService.getDefaultPerspective(
            'grid-view',
            this.gridId() ?? '',
            'MASTER',
          )) ?? null;

        const selectedConfigurationId =
          this.#extractSelectedConfigurationId(userPerspective);

        this.#configPerspective = selectedConfigurationId
          ? await this.#siaComponentConfigService.getPerspective(
              selectedConfigurationId,
            )
          : ((await this.#siaComponentConfigService.getDefaultPerspective(
              'grid',
              this.gridId() ?? '',
              'MASTER',
            )) ?? null);
      }
      if (!this.#configPerspective) {
        this.notify(`No default configuration found `, 2000, 'error');
        return;
      }
      this.#setRetrievedConfiguration(this.#configPerspective, userPerspective);
    }

    await this.#processConfiguration(
      configurationFoundInSession,
      pageFoundInSession,
    );
    if (this.configuration().group?.groupDataField) {
      const groupCol = this.#columns().find(
        (col) => col.id === this.configuration().group?.groupDataField,
      );
      if (groupCol) {
        this.groupByChips.update((chips) => [...chips, groupCol]);
      }
    }
    this.groupByMenuEnabled.set(
      this.#columns().filter((col) => col.colConfig.allowGrouping)?.length >= 2,
    );
    this.#configureColumnChooser();
    if (!configurationFoundInSession || !pageFoundInSession) {
      await this.#processTemplateVisibility();
    }
    this.hasFilterPanel.set(
      await this.#menuService.hasFilterPanel(this.gridId() ?? ''),
    );
  }

  #extractSelectedConfigurationId(
    perspective: SiaComponentConfigPerspectives | null,
  ): string | undefined {
    const jsonConfig = perspective?.jsonConfig;
    if (!jsonConfig) return undefined;

    try {
      const items = JSON.parse(jsonConfig) as Array<{
        id?: string;
        value?: string;
      }>;
      const viewDataValue = items.find((x) => x?.id === 'viewData')?.value;
      if (!viewDataValue) return undefined;

      const viewData = JSON.parse(viewDataValue) as {
        selectedConfigurationId?: string;
      };
      return viewData?.selectedConfigurationId;
    } catch {
      return undefined;
    }
  }

  #ensureGroupConfiguration() {
    if (!this.configuration().group) {
      this.configuration.update((config) => {
        return { ...config, group: {} };
      });
    }
    if (
      this.configuration().groupDataField &&
      !this.configuration().group?.groupDataField
    ) {
      this.configuration.update((config) => ({
        ...config,
        group: {
          ...(config.group ?? {}),
          groupDataField: this.configuration().groupDataField,
        },
      }));
    }
    if (
      this.configuration().groupNameDataField &&
      !this.configuration().group!.groupNameDataField
    ) {
      this.configuration.update((config) => ({
        ...config,
        group: {
          ...(config.group ?? {}),
          groupNameDataField: this.configuration().groupNameDataField,
        },
      }));
    }
    if (
      this.configuration().groupText &&
      !this.configuration().group!.groupText
    ) {
      this.configuration.update((config) => ({
        ...config,
        group: {
          ...(config.group ?? {}),
          groupText: this.configuration().groupText,
        },
      }));
    }
  }

  #setRetrievedConfiguration(
    configPerspective: SiaComponentConfigPerspectives,
    userPerspective: SiaComponentConfigPerspectives | null,
  ) {
    this.configuration.set(JSON.parse(configPerspective.jsonConfig ?? '{}'));
    this.#ensureGroupConfiguration();
    this.selectedGridView.set(userPerspective ?? configPerspective);
    if (this.configuration().group?.groupDataField) {
      const groupCol = this.configuration().cols?.find(
        (col) => col.dataField === this.configuration().group?.groupDataField,
      );
      if (groupCol) {
        groupCol.allowGrouping = true;
        groupCol.groupText = this.configuration().group?.groupText;
      }
    }
    this.configuration.update((config) => ({
      ...config,
      selectionMode:
        this.siaSessionService.getSessionParamValue('selectionMode') ?? '',
    }));
    this.#perSelectedRows =
      this.siaSessionService.getSessionParamValue('selectedids') ?? [];
    this.#foreignKey =
      this.siaSessionService.getSessionParamValue('__foreignkey');
    this.#loadDataParams.selectSpName = this.configuration().selectSpName;

    if (userPerspective && userPerspective.levelType == 'private') {
      let information: {
        id: string;
        type: 'session' | 'local' | 'view';
        value: string;
        guidToReplace: string;
      }[] = JSON.parse(userPerspective.jsonConfig ?? '{}');
      information.forEach((element) => {
        if (element.type == 'session') {
          if (
            element.id.startsWith('filter-panel') &&
            element.id.indexOf('-applied') == -1
          ) {
            let sessionParams: SiaSessionParam[] = JSON.parse(element.value);
            this.siaSessionService.updateSessionParams(
              this.currentGuid,
              sessionParams,
            );
            this.siaParamsAndPatternsService.notifyParamsUpdatedWithGuidFilterPanel(
              this.currentGuid,
            );
            sessionStorage.setItem(
              element.id.replace(element.guidToReplace, this.pageData()!.guid!),
              element.value,
            );
          } else if (element.id.startsWith('params')) {
            sessionStorage.setItem(
              element.id.replace(element.guidToReplace, this.pageData()!.guid!),
              element.value,
            );
            this.siaSessionService.updateSessionParams(
              this.currentGuid,
              JSON.parse(element.value),
            );
          }
        } else {
          if (element.type == 'view') {
            switch (element.id) {
              case 'order':
                this.#stateSort = JSON.parse(element.value);
                break;
              case 'filter':
                this.#filters = JSON.parse(element.value);
                break;
              case 'viewData':
                let viewData = JSON.parse(element.value);
                this.pageSize.set(viewData?.currentPageSize);
                break;
              case 'visible-columns':
                this.#viewVisibleColumns = JSON.parse(element.value);
            }
          }
        }
      });
    }
  }

  async #processConfiguration(
    configurationFoundInSession: boolean,
    pageFoundInSession: boolean,
  ): Promise<void> {
    this.#configurationProcessed = false;
    if (!this.gridId()) {
      this.#configurationProcessed = true;
      return;
    }

    // 1) Handle static actions
    const compId = this.gridId() ?? this.pageData()?.componentId;
    const guid = this.pageData()?.guid ?? '';
    this.#loadDataParams.selectSpName = this.configuration().selectSpName;
    this.siaBaseActionService.handleAction(
      compId ?? '',
      guid,
      'column-chooser',
      this.configuration().actionColumnChooserEnabled ?? false,
    );
    this.siaBaseActionService.handleAction(
      compId ?? '',
      guid,
      'create',
      this.configuration().addingType ? true : false,
    );
    this.siaBaseActionService.handleAction(
      compId ?? '',
      guid,
      'toggle-template',
      this.configuration().switchView ? true : false,
    );

    this.siaBaseActionService.handleAction(
      this.gridId() ?? '',
      this.pageData()?.guid ?? '',
      'fullscreen',
      true,
    );
    this.siaBaseActionService.handleAction(
      this.gridId() ?? '',
      this.pageData()?.guid ?? '',
      'exit-fullscreen',
      false,
    );

    // 3) Global filter panel, massive actions & selection mode
    if (!this.enableGlobalFilterPanel()) {
      this.enableGlobalFilterPanel.set(
        this.configuration().globalFilterEnabled ?? false,
      );
    }
    this.processGridMassiveActions();
    this.#processSelectionMode();

    // 4) Apply column ordering if no session/page override
    if (!configurationFoundInSession && !pageFoundInSession) {
      await this.#orderColumns(this.configuration());
    }

    // 5) Map common settings
    this.#mapCommonSettings(this.configuration(), configurationFoundInSession);

    // 6) Start order & filter pipeline
    await this.#processStartOrderAndFilter(pageFoundInSession);

    // 7) Setup continuous refresh
    if (this.configuration().keepLoadingInterval && this.#editingRow === null) {
      this.#continuousLoadingIntervalId = setInterval(async () => {
        if (this.#configurationProcessed) {
          await this.loadData(true);
        }
      }, this.configuration().keepLoadingInterval! * 1000);
    }

    // 8) Subscribe to params updates
    this.#paramsHardUpdatedSub?.unsubscribe();

    this.#paramsHardUpdatedSub =
      this.siaParamsAndPatternsService.paramsHardUpdated$
        .pipe(
          takeUntil(this.#destroy),
          filter((g) => g === this.pageData()?.guid),
        )
        .subscribe(async () => {
          await this.#processConfigFilter();
          if (this.#configurationProcessed) {
            this.#columns().forEach((col) => {
              col.headerFilterDataSource = [];
            });
            await this.loadData();
          }
        });

    this.siaParamsAndPatternsService.departmentChanged$
      .pipe(takeUntil(this.#destroy))
      .subscribe(async () => {
        await this.#processConfigFilter();
        await this.loadData(true);
      });
    this.#configurationProcessed = true;
    this.#cdr.markForCheck();
  }

  async #loadViews(): Promise<boolean> {
    if (!this.gridId()) {
      return false;
    }

    // Esegue le 3 chiamate in parallelo
    const [gridViews, gridConfigurations, templatePerspectives] =
      await Promise.all([
        this.#siaComponentConfigService
          .getComponentPerspectives('grid-view', this.gridId() ?? '')
          .catch(() => []),
        this.#siaComponentConfigService
          .getComponentPerspectives('grid', this.gridId() ?? '')
          .catch(() => []),
        this.#siaComponentConfigService
          .getComponentPerspectives('grid-template-view', this.gridId() ?? '')
          .catch(() => []),
      ]);
    this.gridViews.set(gridViews ?? []);
    this.gridConfigurations.set(gridConfigurations ?? []);

    this.#privateTemplatePerspective = templatePerspectives?.[0] ?? null;
    if (this.#privateTemplatePerspective) {
      this.#privateTemplateVisibility = JSON.parse(
        this.#privateTemplatePerspective.jsonConfig || '{}',
      );
    }

    const compId = this.gridId() ?? this.pageData()?.componentId ?? '';
    const guid = this.pageData()?.guid ?? '';
    this.siaBaseActionService.disableAction(
      compId,
      guid,
      'perspective-list',
      this.gridViews().length === 0 && this.gridConfigurations().length === 1,
    );
    this.siaBaseActionService.showActionBadge(
      compId,
      guid,
      'perspective-list',
      this.gridViews().length > 0,
    );
    return false;
  }

  async #validateRow(rowData: any): Promise<void> {
    const validationTasks = (this.configuration().cols ?? [])
      .filter((col) => col.allowEditing && !!col.editValidationScript)
      .map((col) => this.execScript(col.editValidationScript!, rowData));

    if (validationTasks.length === 0) {
      return;
    }

    await Promise.all(validationTasks);
  }

  async processRowStyle(data: any, rowIndex: number): Promise<string> {
    // Se è già calcolato, restituisco subito
    const cached = this.#rowStyles[rowIndex];
    if (cached) {
      return cached;
    }

    // Preparo i task per ciascuna condizione
    const conditions = this.configuration().rowStyleConditions ?? [];
    const cssResults = await Promise.all(
      conditions.map(async (style) => {
        if (style.cssStyleCondition) {
          const apply = await this.execScript(style.cssStyleCondition, {
            row: data,
          });
          return apply ? (style.cssStyle ?? '') : '';
        }
        return style.cssStyle ?? '';
      }),
    );

    const rowStyle = ' ' + cssResults.join('');
    this.#rowStyles[rowIndex] = rowStyle;
    this.markOnRowStyleChange();
    if (
      this.lastRowClickedIndex() &&
      (rowIndex === this.currentPageSize() - 1 ||
        (this.totalCount() && rowIndex === this.totalCount()! - 1))
    ) {
      // this.scrollSelectedRowIntoView();
    }

    return rowStyle;
  }

  #processSelectionMode() {
    if (this.configuration().selectionMode) {
      this.selectedRows.set(
        new SelectionModel<any>(
          this.configuration().selectionMode == 'multiple',
          [],
        ),
      );
      let s0 = this.selectedRows()!.changed.subscribe(
        (selection: SelectionChange<any>) => {
          let selectedElement = this.selectedRows()?.selected.map((x) =>
            JSON.parse(x),
          );
          if (
            this.configuration() &&
            this.configuration().selectionMode == 'single' &&
            this.selectedRows()?.selected.length == 1
          ) {
            selectedElement = JSON.parse(
              this.selectedRows()?.selected[0] ?? '{}',
            );
          }
          this.siaRadarService.selectionChanged.next(selectedElement);
        },
      );
      this.#subs.push(s0);
      this.#scheduleOnce(150, 'processSelectionMode', async () => {
        this.selectedRows()?.select(...this.#perSelectedRows);
      });
    } else {
      this.selectedRows.set(undefined);
    }
  }

  processGridMassiveActions() {
    this.siaBaseActionService.handleAction(
      this.gridId() ?? this.pageData()?.componentId ?? '',
      this.pageData()?.guid ?? '',
      'export-excel',
      !this.configuration().exportDisabled,
    );
    this.siaBaseActionService.handleAction(
      this.gridId() ?? this.pageData()?.componentId ?? '',
      this.pageData()?.guid ?? '',
      'massive-delete',
      this.configuration().allowMassiveDelete ?? false,
    );
    this.siaBaseActionService.handleAction(
      this.gridId() ?? this.pageData()?.componentId ?? '',
      this.pageData()?.guid ?? '',
      'massive-update',
      this.configuration().allowMassiveUpdate ?? false,
    );
  }

  async #processStartOrderAndFilter(foundInSession: boolean = false) {
    if (!foundInSession && !this.#stateSort) {
      let columnsToSortOnStart = this.#columns().filter((x) =>
        x.colConfig.sortOrder
          ? true
          : x.colConfig.sortIndex && x.colConfig.sortIndex != 0,
      );
      columnsToSortOnStart.sort((a, b) => {
        return (a.colConfig.sortIndex ?? 0) - (b.colConfig.sortIndex ?? 0);
      });
      columnsToSortOnStart.forEach((column, index) => {
        column.sortIndex = index + 1;
        column.orderByDirection = column.colConfig.sortOrder ?? 'asc';
      });
    } else if (this.#stateSort) {
      if (!Array.isArray(this.#stateSort)) {
        let arrStateSort = this.#stateSort as {
          dirs: string[];
          params: string[];
        };
        this.#stateSort = arrStateSort.params.map((x, i) => {
          return {
            id: arrStateSort.params[i],
            index: i,
            direction: arrStateSort.dirs[i],
          };
        });
      }
      this.#stateSort.forEach((element) => {
        let column = this.#columns().find((x) => x.id == element.id);
        if (column) {
          column.sortIndex = element.index;
          column.orderByDirection = element.direction;
        }
      });
    }
    await firstValueFrom(
      this.siaParamsAndPatternsService.firstFilterLoaded$.pipe(
        filter((guid) => !!guid[this.pageData()?.guid ?? '']),
        take(1),
      ),
    );

    // this.#canLoadData = true;
    await this.#processConfigFilter();
  }

  async #processConfigFilter() {
    const promises = this.#columns()
      .filter(
        (x) => x.colConfig.prefilters && x.colConfig.prefilters.length > 0,
      )
      .map(async (column) => {
        column.additionalFilters = [];
        let filters = column.colConfig.prefilters;
        if (!filters) {
          return Promise.resolve();
        }
        if (filters?.length == 1 && filters[0].valueScript) {
          column.filterOperator = filters[0].filterOperation;
          var value = await this.execScript(filters[0].valueScript, {
            multiGridFilters: this.#multiGridFilters,
          });
          column.filterValue = jsonDeepClone(value);
        } else {
          filters.forEach(async (filter) => {
            if (filter.valueScript) {
              let filterOperator = filter.filterOperation;
              let filterValue = await this.execScript(filter.valueScript, {
                multiGridFilters: this.#multiGridFilters,
              });
              column.additionalFilters = column.additionalFilters ?? [];
              if (filterValue != null && filterValue != '') {
                column.additionalFilters.push({
                  filterOperator,
                  filterValue,
                });
              }
            }
          });
        }
      });
    await Promise.all(promises);
    await this.#calcFilters();
    await this.setValueSpParams();
  }

  async saveCurrentViewAsPerspective() {
    if (!this.pageData()?.guid) {
      notify('Impossibile salvare la vista', 1500, 'error');
      return;
    }

    let currentView: {
      id: string;
      type: 'session' | 'local' | 'view';
      value: string;
      guidToReplace: string;
    }[] = [];
    let sessionKeys = Object.keys(sessionStorage);
    sessionKeys.forEach((sessionKey) => {
      if (
        sessionKey.indexOf(this.pageData()!.guid!) != -1 &&
        sessionKey.indexOf(`filter-panel-${this.pageData()?.guid}`) != -1
      ) {
        currentView.push({
          id: sessionKey,
          type: 'session',
          value: sessionStorage.getItem(sessionKey) ?? '',
          guidToReplace: this.pageData()!.guid!,
        });
        if (
          sessionKey.indexOf(`filter-panel-${this.pageData()?.guid}`) != -1 &&
          sessionKey.indexOf('-applied') == -1
        ) {
          let filterParams: SiaSessionParam[] = JSON.parse(
            sessionStorage.getItem(sessionKey) ?? '[]',
          );
          filterParams.forEach((sessionParam) => {
            sessionParam.value = this.siaSessionService.getSessionParamValue(
              sessionParam.id ?? '',
              this.currentGuid,
            );
          });
          currentView.push({
            id: 'params-' + this.currentGuid,
            type: 'session',
            value: JSON.stringify(filterParams),
            guidToReplace: this.pageData()!.guid!,
          });
        }
      }
    });
    currentView.push({
      id: 'viewData',
      type: 'view',
      value: JSON.stringify({
        currentPageIndex: 0,
        currentPageSize: this.currentPageSize(),
        selectedConfigurationId: this.selectedGridView()?.id ?? '',
        lastRowClicked: null,
      }),
      guidToReplace: '',
    });

    currentView.push({
      id: 'visible-columns',
      type: 'view',
      value: JSON.stringify(
        this.#columns().map((col: SiaGridColumnInstance) => {
          return {
            id: col.id,
            visibleIndex: col.visibleIndex,
            isActive: col.isActive,
            colConfig: {
              width: col.colConfig.currentWidth
                ? col.colConfig.currentWidth?.toString() + 'px'
                : null,
              prefilters: jsonDeepClone(col.colConfig.prefilters),
            },
            filterOperator: col.filterOperator,
            filterValue: col.filterValue,
            headerFilterValue: jsonDeepClone(col.headerFilterValue),
          };
        }),
      ),
      guidToReplace: '',
    });

    currentView.push({
      id: 'filter',
      type: 'view',
      value: JSON.stringify(this.#activeColumnsFilters),
      guidToReplace: '',
    });
    currentView.push({
      id: 'order',
      type: 'view',
      value: JSON.stringify(
        this.#columns()
          .filter((x) => x.sortIndex)
          .map((x) => {
            return {
              id: x.id,
              index: x.sortIndex,
              direction: x.orderByDirection,
            };
          }),
      ),
      guidToReplace: '',
    });
    let dialogRef = this.dialog.open(SaveGridViewDialogComponent, {
      width: 'min(400px , 98%)',
      height: 'fit-content',
      data:
        this.selectedGridView()?.levelType == 'private'
          ? this.selectedGridView()
          : {},
    });

    let perspective: SiaComponentConfigPerspectives = await firstValueFrom(
      dialogRef.afterClosed(),
    );

    if (!perspective) {
      return;
    }
    if (perspective.id && this.selectedGridView()) {
      this.selectedGridView()!.description = perspective.description;
      this.selectedGridView()!.jsonConfig = JSON.stringify(currentView);
      this.selectedGridView()!.isPrivate = true;
      this.selectedGridView()!.defaultMode = perspective.defaultMode;
      let updated =
        await this.#siaComponentConfigService.updateComponentPerspective(
          this.selectedGridView()!,
        );
      await this.#siaComponentConfigService.updateComponentPerspectiveInfo(
        this.selectedGridView()!,
      );
      if (updated) {
        this.notify('Vista aggiornata con successo', 1500, 'success');
      } else {
        this.notify('Impossibile aggiornare la vista', 1500, 'error');
      }
    } else {
      perspective = {
        componentId: this.gridId() ?? this.pageData()!.componentId,
        configType: 'grid-view',
        jsonConfig: JSON.stringify(currentView),
        isPrivateAndSingle: false,
        isPrivate: true,
        userId: this.user?.id,
        description: perspective.description,
        defaultMode: perspective.defaultMode,
      };
      var perspectiveSaved =
        await this.#siaComponentConfigService.setComponentPerspective(
          perspective,
        );
      if (perspectiveSaved) {
        this.notify('Vista salvata con successo', 1500, 'success');
        this.#lastSelectedGridView = perspectiveSaved;
        this.selectedGridView.set(perspectiveSaved);
        this.#loadViews();
      } else {
        this.notify('Impossibile salvare la vista', 1500, 'error');
      }
    }
  }

  async deleteCurrentView() {
    if (!this.selectedGridView()) {
      notify('Nessuna vista selezionata', 1500, 'warning');
      return;
    }
    if (this.selectedGridView()?.levelType != 'private') {
      notify(
        'Impossibile eliminare una prospettiva non privata',
        1500,
        'error',
      );
      return;
    }
    let deleted = await this.#siaComponentConfigService.deletePerspective(
      this.selectedGridView()?.id ?? '',
    );
    if (deleted) {
      this.selectedGridView.set(undefined);
      this.#loadViews();
      this.notify('Vista eliminata con successo', 1500, 'success');
    } else {
      this.notify('Impossibile eliminare la vista', 1500, 'error');
    }
    if (this.gridId() == this.pageData()?.componentId) {
      this.#siaLayoutService.showAdditionalTitle(
        this.#firstAdditionalTitle ?? '',
        this.pageData()?.guid ?? '',
      );
    }
    this.selectedGridViewOutput.emit('');
    await this.#resetProperties(false, false);
    this.loadConfiguration();
  }

  pageChanged(event: PageEvent) {
    this.currentPageIndex.set(event.pageIndex);
    this.pageSize.set(event.pageSize);
    this.lastRowClickedIndex.set(undefined);
    this.#scrollToTop();
    this.#rowStyles = {};
    this.#rowStylesInProgress = [];
  }

  saveEdits(rowData: any) {
    if (!this.gridId()) {
      return;
    }

    // 1) Costruisco gridData
    const changedData: any = {};
    this.#columns()
      .filter((c) => c.colConfig.allowEditing)
      .forEach((c) => (changedData[c.id] = rowData[c.id]));

    const pkValue = rowData['__primary-key'];
    const pkObj = typeof pkValue === 'string' ? JSON.parse(pkValue) : pkValue;
    Object.entries(pkObj).forEach(([field, value]) => {
      changedData['_' + field] = value;
    });

    this.#primaryKeys.forEach((key) => {
      changedData[key] = rowData[key];
    });

    const gridData: GridHttpParams = {
      componentId: this.gridId(),
      jsonData: JSON.stringify(changedData),
    };

    const wasAdding = this.#rowAdding || rowData.__isAdding;
    const rowTempId = rowData.__tempId;
    const rowPrimaryKey = rowData['__primary-key'];

    // 2) RxJS-flusso: valida → scelta insert/update → chiamata service → notifiche
    from(this.#validateRow(rowData))
      .pipe(
        takeUntil(this.#destroy),

        // 3) Se scriptCanContinue è false, reset e stop
        switchMap(() => {
          if (!this.#scriptCanContinue) {
            this.#scriptCanContinue = true;
            return EMPTY;
          }
          // 4) Insert o update
          return wasAdding
            ? from(this.#siaGridService.insertRow(gridData))
            : from(this.#siaGridService.updateRow(gridData));
        }),

        // 5) Notifiche a valle e rimozione dalla lista editing
        tap((res) => {
          if (res) {
            // Clear the single editing row if it matches
            if (
              this.#editingRow &&
              (this.#editingRow.__tempId === rowTempId ||
                (this.#editingRow['__primary-key'] &&
                  this.#editingRow['__primary-key'] === rowPrimaryKey))
            ) {
              this.#editingRow = null;
            }

            if (wasAdding) {
              this.#rowAdding = false;
              this.notify('Inserito con successo', 1500, 'success');
            } else {
              rowData['__editing'] = false;
              this.notify('Modificato con successo', 1500, 'success');
            }

            // Reload data to get fresh server data
            if (this.#configurationProcessed) {
              void this.loadData(true);
            }
          }
        }),

        // 6) Error handling centralizzato
        catchError((err) => {
          this.notify('Impossibile salvare', 1500, 'error');
          return EMPTY;
        }),
      )
      .subscribe();
  }

  #scheduleOnce(delayMs: number, id: string, action: () => void) {
    if (this.#scheduledTimeouts[id]) {
      clearTimeout(this.#scheduledTimeouts[id]);
    }
    this.#scheduledTimeouts[id] = setTimeout(() => {
      delete this.#scheduledTimeouts[id];
      action();
    }, delayMs);
  }

  async valueChanged(event: any, column: SiaGridColumnInstance, element: any) {
    this.#scheduleOnce(300, 'valueChanged', async () => {
      const columnConfiguration = this.configuration().cols?.find(
        (x) => x.dataField == column.id,
      );
      if (!columnConfiguration?.dataChangeValidationScript) {
        // Even without validation script, sync to _editingRows if editing
        if (element.__editing) {
          this.#syncToEditingRows(element);
        }
        return;
      }
      element[column?.id + '__errorMessage'] = await this.execScript(
        columnConfiguration?.dataChangeValidationScript ?? '',
        event,
      );
      element[column?.id + '__errorStatus'] = null;
      if (element[column?.id + '__errorMessage']) {
        element[column?.id + '__errorStatus'] = 'error';
      }

      // Sync changes to _editingRows
      if (element.__editing) {
        this.#syncToEditingRows(element);
      }
    });
  }

  #syncToEditingRows(rowData: any) {
    if (this.#editingRow && this.#editingRow.__tempId === rowData.__tempId) {
      Object.assign(this.#editingRow, rowData);
    }
  }

  async reassignColumnsWidth() {
    if (this.showTemplate()) {
      this.columnsWithSet.set(true);
      return;
    }
    if (
      !this.dataSource() ||
      !this.#columns()?.length ||
      !this.#host?.nativeElement
    ) {
      this.setEmptyRowHeight();
      return;
    }

    // attendo il ciclo di stabilizzazione di Angular per essere certo che le colonne esistano nel DOM
    await firstValueFrom(this.#ngZone.onStable);

    const hasDomColumns = this.columnsIds().every((c) =>
      this.#host.nativeElement.querySelector('.mat-column-' + c),
    );
    if (!hasDomColumns) {
      this.#scheduleOnce(100, 'reassignColumnsWidth', () => {
        this.reassignColumnsWidth();
      });
      return;
    }
    for (const element of this.#columns()) {
      if (element.colConfig.currentWidth) {
        this.#setCssColumnsWidth(element, element.colConfig.currentWidth);
        element.widthSetted = true;
        continue;
      }

      if (element.colConfig.width && !element.widthSetted) {
        this.#setCssColumnsWidth(element, element.colConfig.width);
        element.widthSetted = true;
      }
    }
    this.#setAdaptiveColumnsWidth();
    this.#updateMatTableStickyStyle();
    this.columnsWithSet.set(true);
    this.setEmptyRowHeight();
    this.#gridColumnsWidthSet.set(true);
    for (const element of this.#columns()) {
      element.colConfig.currentWidth = $(
        '.' + this.gridId() + ' .mat-column-' + element.id,
      ).outerWidth();
    }
  }

  #setAdaptiveColumnsWidth() {
    try {
      let currentTotalWidth =
        (this.#host.nativeElement as HTMLElement).offsetWidth ?? 0;
      currentTotalWidth = currentTotalWidth - 2;
      if (this.configuration().selectionMode) {
        currentTotalWidth = currentTotalWidth - 75;
        $('.' + this.gridId() + ' .mat-column-__selection-column')?.css(
          'width',
          '75px',
        );
      }
      if (this.configuration().rowEditingEnabled) {
        currentTotalWidth = currentTotalWidth - 90;
        $('.' + this.gridId() + ' .mat-column-__action-column')?.css(
          'width',
          '90px',
        );
      }
      if (this.focusClickedRow() && !this.fullScreen()) {
        currentTotalWidth = currentTotalWidth - 60;
        $('.' + this.gridId() + ' .mat-column-__focus-row-column')?.css(
          'width',
          '60px',
        );
      }

      // account for placeholder group columns added for grouping/tabbing
      if (this.numberGroups()?.length) {
        const groupColumnWidth = 32;
        this.numberGroups().forEach((groupIndex) => {
          const selector =
            '.' + this.gridId() + ' .mat-column-group' + groupIndex;
          const width = $(selector).outerWidth() ?? groupColumnWidth;
          if (width) {
            currentTotalWidth -= width;
            $(selector)?.css('width', (width || groupColumnWidth) + 'px');
          }
        });
      }

      const adjustableColumns = jsonDeepClone(
        this.#columns().filter((x) => x.isActive && !x.colConfig.width),
      );

      let settedColumns = this.#columns().filter((x) => !!x.colConfig.width);

      settedColumns.forEach((column: any) => {
        const width = $(
          '.' + this.gridId() + ' .mat-column-' + column.id,
        ).outerWidth();
        if (width) {
          currentTotalWidth -= width;
        }
      });
      // Collect only active columns still needing width assignment

      // If there are no columns to adjust, avoid division by zero (Infinity)
      if (adjustableColumns.length === 0) {
        return; // Nothing left to do
      }

      let newWidth = (currentTotalWidth - 10) / adjustableColumns.length;

      // Guard against invalid widths (Infinity, -Infinity, NaN, negative or zero)
      if (!isFinite(newWidth) || newWidth <= 0) {
        // Fallback: try to use the max of declared minWidths or a sensible default (120px)
        const fallback = Math.max(
          120,
          ...adjustableColumns
            .map((c: any) => (c.colConfig.minWidth ? +c.colConfig.minWidth : 0))
            .filter((v: any) => v > 0),
        );
        newWidth = fallback;
      }

      adjustableColumns.map((column: any) => {
        // Respect minWidth constraint if any
        if (
          column.colConfig.minWidth &&
          newWidth < +column.colConfig.minWidth
        ) {
          this.#setCssColumnsWidth(column, column.colConfig.minWidth);
          let width = $(
            '.' + this.gridId() + ' .mat-column-' + column.id,
          ).outerWidth();
          column.colConfig.currentWidth = width;
        } else {
          column.colConfig.currentWidth = newWidth;
          this.#setCssColumnsWidth(column, column.colConfig.currentWidth);
        }
        column.widthSetted = true;
      });
    } catch (error) {
      console.error('set Adaptive Columns Width error', error);
    }
  }

  async toggleAllRows() {
    if (!this.selectedRows()) return;

    if (this.isAllSelected()) {
      this.selectedRows.set(
        new SelectionModel<any>(
          this.configuration().selectionMode === 'multiple',
          [],
        ),
      );
      return;
    }

    let loadAllDataParams: SiaGridPageRequest = jsonDeepClone(
      this.#loadDataParams,
    );
    loadAllDataParams.columns = this.#primaryKeys;
    loadAllDataParams.skip = 0;
    loadAllDataParams.take = this.totalCount() ?? 0;
    let dataSource = await this.#siaGridService.loadData(loadAllDataParams);

    // Create a new SelectionModel with the loaded items
    const newSelection = new SelectionModel<any>(
      this.configuration().selectionMode === 'multiple',
      dataSource.items?.map((x) => JSON.stringify(x)) ?? [],
    );
    this.selectedRows.set(newSelection);
  }

  getFilterHtml(filterId?: string) {
    if (!filterId) {
      return '';
    }
    return this.#sqlFiltersType.allFilters.find((x) => x.id == filterId)?.icon;
  }

  applyFilters() {
    this.loadData();
  }

  applyGlobalFilter() {
    if (this.#applyFiltersTimeout) {
      clearTimeout(this.#applyFiltersTimeout);
    }
    this.#applyFiltersTimeout = setTimeout(async () => {
      await this.loadData();
      // highlight might need refresh even if rows do not change
      this.markOnRowStyleChange();
    }, 400);
  }

  async dateRangeValueChange(column: any, eventDate: any, position: number) {
    if (!Array.isArray(column.filterValue)) {
      column.filterValue = [];
    }
    column.filterValue[position] = eventDate.value;
    if (position == 1 && eventDate.value) {
      await this.#calcFilters();
      this.applyFilters();
    }
  }

  getIconClass = (icon: string | undefined): string => {
    switch (icon) {
      case 'error':
      case 'delete':
      case 'cancel':
        return '!text-error';
      case 'check_circle':
        return '!text-success';
      case 'diamond_shine':
        return '!animate-pulse !text-amber-500 !shadow-[0_0_15px_rgba(245,158,11,0.5)]';
      default:
        return '';
    }
  };

  getFiltersByType(type: string) {
    switch (type.toLowerCase()) {
      case 'string':
        return this.#sqlFiltersType.stringFilters;
      case 'number':
        return this.#sqlFiltersType.numberFilters;
      case 'date':
      case 'time':
      case 'datetime':
        return this.#sqlFiltersType.dateFilters;
      default:
        return this.#sqlFiltersType.allFilters;
    }
  }
  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!this.selectedRows()) return '';

    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selectedRows()?.isSelected(row) ? 'deselect' : 'select'} row ${
      row.position + 1
    }`;
  }

  async manageSiaSignalrMessage(message: any) {
    if (!message[this.gridId() ?? ''] && !message['*']) {
      return;
    }
    if (this.#configurationProcessed) {
      await this.loadData(true);
    }
  }

  async getCellClass(data: any, column: SiaGridColConfig) {
    let cellClass = ' sia-mat-grid-cell ';
    if (!column.isFullText) {
      cellClass += ' sia-mat-grid-cell--compact';
    }
    if (!column.scriptOnClick) {
      data['class_' + column.dataField] = cellClass;
      return cellClass;
    }

    let applyClass = true;
    if (column.scriptClickEnabled) {
      applyClass = await this.execScript(column.scriptClickEnabled, {
        row: data,
        cell: data[column.dataField?.toLowerCase() ?? ''],
      });
    }
    if (
      applyClass &&
      (!column.styleConditions || column.styleConditions.length == 0)
    ) {
      cellClass += ' sia-mat-grid-cell--clickable';
    } else if (
      applyClass &&
      column.styleConditions &&
      column.styleConditions.length > 0
    ) {
      cellClass += ' text-[var(--mat-sys-primary)]'; //tolto important per permettere l'override da parte di condizioni di stile
    }
    data['class_' + column.dataField] = cellClass;
    return cellClass;
  }

  async getCellStyle(data: any, column: SiaGridColConfig, rowIndex: number) {
    let rowStyle = '';
    if (this.#rowStyles[rowIndex] !== undefined) {
      rowStyle = this.#rowStyles[rowIndex];
    } else {
      if (!this.#rowStylesInProgress[rowIndex]) {
        this.#rowStylesInProgress[rowIndex] = this.processRowStyle(
          data,
          rowIndex,
        );
      }
      rowStyle = (await this.#rowStylesInProgress[rowIndex]) ?? '';
    }
    let cellStyle = ' ';
    if (column.styleConditions && column.styleConditions.length > 0) {
      for (const style of column.styleConditions) {
        let applyClass = true;
        if (style.cssStyleCondition) {
          applyClass = await this.execScript(style.cssStyleCondition, {
            row: data,
            cell: data[column.dataField?.toLowerCase() ?? ''],
          });
        }
        if (applyClass) {
          const resultStyle = (style.cssStyle ?? '').replace(
            /\[([^\]]+)\]/g,
            (match, p1) => {
              return data[p1] || match; // If the property doesn't exist, keep the placeholder
            },
          );
          cellStyle += resultStyle ?? '';
        }
      }
    }
    if (column.rowsNumber) {
      data['span-style_' + column.dataField] =
        ` display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: ${column.rowsNumber}; overflow: hidden; `;
    }
    data['style_' + column.dataField] = cellStyle += rowStyle;
    return cellStyle;
  }

  markOnRowStyleChange() {
    this.#scheduleOnce(400, 'markOnRowStyleChange', async () => {
      if (this.globalFilter()) {
        this.#markInstance?.unmark();
        let tableElement = document.getElementById(this.gridId() ?? '');
        let dataRows = tableElement?.querySelectorAll('.mat-row');
        if (dataRows && dataRows.length > 0) {
          this.#markInstance = new markJs(dataRows);
          this.#markInstance.mark(this.globalFilter() ?? '', {
            element: 'mark',
            className: 'highlight',
          });
        }
        tableElement = null;
      } else {
        this.#markInstance?.unmark();
      }
      this.#columns()
        .filter(
          (x) => x.markController && JSON.stringify(x.markController) != '{}',
        )
        ?.forEach((columnToUnmark) => {
          columnToUnmark.markController?.unmark();
        });

      let columnsToMark = this.#columns().filter(
        (x) => x.filterValue && x.colConfig.dataType == 'string',
      );
      if (columnsToMark.length == 0) {
        return;
      }
      columnsToMark?.forEach((column) => {
        let columns = document.querySelectorAll(
          ' #' + this.gridId() + ' .mat-row .mat-column-' + column.id,
        );
        if (columns && column && column.filterValue) {
          column.markController = new markJs(columns);
          if (!column.markController) {
            return;
          }
          if (typeof column.filterValue === 'string') {
            column.markController.mark(column.filterValue ?? '', {
              element: 'mark',
              className: 'highlight',
            });
          }
        }
      });
    });
  }

  async #scrollSelectedRowIntoView(selectedRow: HTMLElement | null = null) {
    if (selectedRow && selectedRow && !this.compactViewActive()) {
      this.#scheduleOnce(150, 'scrollSelectedRowIntoView', async () => {
        const contentBody = document.querySelector(`#${this.gridId()}`);
        if (contentBody) {
          const rowRect = selectedRow!.getBoundingClientRect();
          const containerRect = contentBody.getBoundingClientRect();
          const relativeTop = rowRect.top - containerRect.top;
          contentBody.scrollTop =
            contentBody.scrollTop +
            relativeTop -
            containerRect.height / 2 +
            rowRect.height / 2;
        }
      });
    }
  }

  #scrollToTop() {
    const contentBody = document.querySelector(`#${this.gridId()}`);
    if (contentBody) {
      contentBody.scrollTop = 0;
    }
  }

  #exportTOExcel() {
    // 1) Preparo i parametri
    const exportCols = this.#columns()
      .filter((c) => c.colConfig.allowExporting)
      .map((c) => c.id);

    const columnsToExport =
      exportCols.length > 0
        ? exportCols
        : this.#columns()
            .filter(
              (c) =>
                c.isActive &&
                c.dataType != 'action' &&
                c.dataType != 'avatar' &&
                c.dataType != '',
            )
            .map((c) => c.id);

    const params: SiaGridPageRequest = {
      ...jsonDeepClone(this.#loadDataParams),
      columns: columnsToExport,
      skip: 0,
      take: this.totalCount() ?? 0,
    };

    // 2) Carico i dati come Observable
    from(this.#siaGridService.loadData(params))
      .pipe(
        takeUntil(this.#destroy),

        // 3) Se non ci sono righe, esco
        filter((ds) => Array.isArray(ds.items) && ds.items.length > 0),

        // 4) Costruisco sincronicamente workbook + worksheet
        map((ds) => {
          const workbook = new Workbook();
          const worksheet = workbook.addWorksheet('Grid') as Worksheet;

          // colonne e stili di base
          const cols: Partial<Column>[] = params.columns!.map((key) => {
            const cfg = this.#columns().find((c) => c.id === key)!.colConfig!;
            return {
              header: this.#columns().find((c) => c.id === key)!.headerName,
              key,
              style:
                cfg.dataType === 'number'
                  ? {
                      numFmt:
                        '0' +
                        (cfg.excelConfiguration?.decimalPlaces
                          ? '.' +
                            '0'.repeat(cfg.excelConfiguration.decimalPlaces)
                          : ''),
                    }
                  : undefined,
            };
          });
          worksheet.columns = cols as Column[];

          // header styling
          const headerFill = {
            type: 'pattern' as const,
            pattern: 'solid' as const,
            fgColor: { argb: 'F0C4C4C4' },
          };
          worksheet.getRow(1).eachCell((cell) => {
            cell.fill = headerFill;
            cell.font = { bold: true, size: 13 };
            cell.alignment = { wrapText: true, vertical: 'top' };
          });

          // righe
          ds.items?.forEach((item) => {
            // Fix per le date: converto le date in stringa locale per evitare lo shift di timezone
            params.columns!.forEach((key) => {
              const cfg = this.#columns().find((c) => c.id === key)!.colConfig!;

              // Controllo più esteso per identificare le colonne date
              const isDateColumn =
                cfg.dataType?.toLowerCase().includes('date') ||
                cfg.dataType?.toLowerCase().includes('time') ||
                cfg.dataType?.toLowerCase() === 'datetime';

              if (isDateColumn && item[key] != null && item[key] !== '') {
                let dateValue: Date | null = null;

                // Gestisco diversi formati di input
                if (item[key] instanceof Date) {
                  // Se è già un oggetto Date
                  dateValue = item[key];
                } else if (typeof item[key] === 'string') {
                  // Se è una stringa, provo a parsarla
                  dateValue = new Date(item[key]);
                } else if (typeof item[key] === 'number') {
                  // Se è un timestamp numerico
                  dateValue = new Date(item[key]);
                }

                // Se ho una data valida, la converto in stringa locale
                if (dateValue && !isNaN(dateValue.getTime())) {
                  // Converto in formato locale italiano per evitare problemi di timezone
                  if (
                    cfg.dataType?.toLowerCase().includes('time') ||
                    cfg.dataType?.toLowerCase() === 'datetime'
                  ) {
                    // Per datetime includo anche l'ora
                    item[key] = dateValue.toLocaleString('it-IT');
                  } else {
                    // Per date solo la data
                    item[key] = dateValue.toLocaleDateString('it-IT');
                  }
                }
              }
            });
            worksheet.addRow(item);
          });

          // per ogni colonna, eachCell + formule + conditional formatting
          worksheet.columns.forEach((col, i) => {
            const cfg = this.#columns().find(
              (c) => c.id === col.key,
            )!.colConfig!;
            // formula di colonna
            const formulaTpl = cfg.excelConfiguration?.formulaCell;
            const formula = formulaTpl
              ? this.#replaceIdColumn(formulaTpl, worksheet)
              : null;

            let maxLength = 0;
            if (typeof col.eachCell === 'function') {
              col.eachCell({ includeEmpty: true }, (cell) => {
                // wrap/align
                cell.alignment = {
                  wrapText: cfg.excelConfiguration?.isWrapText,
                  vertical: 'top',
                  horizontal: cfg.excelConfiguration?.alignText,
                };
                // formula
                if (formula && cell.fullAddress.row !== 1) {
                  cell.value = { formula };
                }
                // cellColor su header
                if (
                  cell.fullAddress.row === 1 &&
                  cfg.excelConfiguration?.colColor
                ) {
                  cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: cfg.excelConfiguration.colColor.slice(1) },
                  };
                }
                // misura lunghezza
                const len = cell.value?.toString().length ?? 10;
                maxLength = Math.max(
                  maxLength,
                  cfg.dataType?.startsWith('date') ? 15 : len + 5,
                );
              });
            }
            // assegno width
            col.width = cfg.excelConfiguration?.isWrapText
              ? (cfg.excelConfiguration.colWidth ?? 10)
              : Math.max(maxLength, 10);

            // conditional formatting
            cfg.excelConfiguration?.formatting
              ?.filter((f) => !!f.formula)
              .forEach((f) => {
                const expr = this.#replaceIdColumn(f.formula!, worksheet);
                worksheet.addConditionalFormatting({
                  ref: col.letter + ':' + col.letter,
                  rules: [
                    {
                      type: 'expression',
                      formulae: [expr],
                      priority: 10,
                      style: {
                        font: { color: { argb: f.textColor?.slice(1) } },
                        fill: {
                          type: 'pattern',
                          pattern: 'solid',
                          bgColor: { argb: f.bgColor?.slice(1) },
                        },
                      },
                    },
                  ],
                });
              });
          });

          return workbook;
        }),

        // 5) Genero il buffer (Promise → Observable)
        switchMap((workbook) => from(workbook.xlsx.writeBuffer())),

        // 6) Salvo il file
        tap((buffer) => {
          saveAs(
            new Blob([buffer], { type: 'application/octet-stream' }),
            `${this.configuration().exportFileName ?? 'Grid'}.xlsx`,
          );
        }),

        // 7) Error handling
        catchError((err) => {
          this.notify('Errore durante esportazione Excel', 2000, 'error');
          return EMPTY;
        }),
      )
      .subscribe();
  }

  #replaceIdColumn(format: string, worksheet: Worksheet): string {
    let toReplace: RegExpExecArray | null;
    let reg = /@([^@]*)@/g;
    if (format != undefined) {
      while (
        (toReplace = reg.exec(format)) !== null &&
        toReplace &&
        toReplace.length > 0
      ) {
        let columnReplace = worksheet.columns.find(
          (x) => x.key == toReplace![1],
        );

        if (!columnReplace) {
          continue;
        }
        format = format?.replace(
          toReplace![0],
          '"' + columnReplace!.letter + '"',
        );
      }
    }
    return format;
  }

  async getActionIcon(data: any, column: SiaGridColConfig) {
    let icon: string;
    if (!column.actionIconScript) {
      icon = column.actionIcon ?? '';
    } else {
      icon = await this.execScript(column.actionIconScript, {
        row: data,
        cell: data[column.dataField?.toLowerCase() ?? ''],
      });
    }
    if (!icon) {
      icon = ' ';
    }
    data['icon_' + column.dataField] = icon;
    return icon;
  }
  async getActionText(data: any, column: SiaGridColConfig) {
    let text: string;
    if (!column.actionTextScript) {
      text = column.actionText ?? '';
    } else {
      text = await this.execScript(column.actionTextScript, {
        row: data,
        cell: data[column.dataField?.toLowerCase() ?? ''],
      });
    }
    if (!text) {
      text = ' ';
    }
    data['text_' + column.dataField] = text;
    return text;
  }

  saveStatus(gridId?: string, guid?: string) {
    let { temporaryKey, configKey, columnsKey, filterKey, orderKey } =
      this.#generateStatusKeys(gridId, guid);
    let temporaryData = {
      currentPageIndex: this.currentPageIndex(),
      currentPageSize: this.currentPageSize(),
      lastRowClicked: this.lastRowClickedIndex(),
      lastRowClickedData: this.#lastRowClickedData(),
      perspectiveId: this.selectedGridView()?.id ?? null,
    };
    this.siaSessionService.set(temporaryKey, temporaryData);
    this.siaSessionService.weakMemorySet(configKey, this.configuration());
    this.siaSessionService.set(columnsKey, this.#columns());
    this.siaSessionService.set(filterKey, this.#filters);
    this.siaSessionService.set(
      orderKey,
      this.#columns()
        .filter((x) => x.sortIndex)
        .map((x) => {
          return {
            id: x.id,
            index: x.sortIndex,
            direction: x.orderByDirection,
          };
        }),
    );
  }

  async processSummaryScript(column: SiaGridColConfig) {
    if (!column.summaryValue) {
      column.summaryScriptApplied = true;
      column.summaryValue = '';
      return;
    }
    var res = await this.execScript(column.summaryScript!, {
      data: column.summaryValue,
    });
    if (res) {
      column.summaryScriptApplied = true;
      column.summaryValue = res;
    }
    this.#cdr.markForCheck();
    return res;
  }

  #generateStatusKeys(gridId?: string, guid?: string) {
    gridId = gridId ?? this.gridId();
    guid = guid ?? this.pageData()?.guid;
    let configKey = gridId + '-config';
    let temporaryKey = `${gridId}-${guid}`;
    let columnsKey = `${gridId}-${guid}-columns`;
    let filterKey = `${gridId}-${guid}-filter`;
    let orderKey = `${gridId}-${guid}-order`;
    return { temporaryKey, configKey, columnsKey, filterKey, orderKey };
  }

  checkActionSelection(rowData: any) {
    let allowSelect = true;
    if (!rowData['__allowselection']) {
      allowSelect = false;
    }
    if (
      allowSelect &&
      this.pageData()?.mode == 'update' &&
      (this.selectedRows()?.selected.length ?? 0) > 0
    ) {
      if (
        rowData['__massiveoperationcrud'] !=
        JSON.parse(this.selectedRows()?.selected[0] ?? '{}')[
          '__massiveoperationcrud'
        ]
      ) {
        allowSelect = false;
      }
    }
    return allowSelect;
  }

  #clearStatus() {
    let { temporaryKey, configKey, columnsKey, filterKey, orderKey } =
      this.#generateStatusKeys();
    this.siaSessionService.weakMemoryClear(configKey);
    this.siaSessionService.clear(temporaryKey);
    this.siaSessionService.clear(columnsKey);
    this.siaSessionService.clear(filterKey);
    this.siaSessionService.clear(orderKey);
  }

  async #getStatus(): Promise<[boolean, boolean]> {
    let { temporaryKey, configKey, columnsKey, filterKey, orderKey } =
      this.#generateStatusKeys();
    this.#columns.set(this.siaSessionService.get(columnsKey) ?? []);
    this.#filters = this.siaSessionService.get(filterKey) ?? [];
    this.configuration.set(
      this.siaSessionService.weakMemoryGet(configKey) ?? {},
    );
    let configurationFound = true;
    if (
      !this.configuration() ||
      JSON.stringify(this.configuration()) === '{}'
    ) {
      configurationFound = false;
    }
    this.#ensureGroupConfiguration();
    await this.#processTemplateVisibility();
    this.#stateSort = this.siaSessionService.get(orderKey) ?? [];
    this.#columns().map((x) => {
      x.widthSetted = false;
      x.colConfig.currentWidth = undefined;
    });
    if (!this.#columns() || this.#columns().length == 0) {
      return [false, false];
    }
    let temporaryData = this.siaSessionService.get(temporaryKey);
    if (temporaryData && JSON.stringify(this.configuration()) != '{}') {
      this.pageSize.set(temporaryData?.currentPageSize);
      this.currentPageIndex.set(temporaryData?.currentPageIndex);
      this.lastRowClickedIndex.set(temporaryData?.lastRowClicked);
      this.toggleCompactMode(
        temporaryData?.lastRowClickedData,
        temporaryData?.lastRowClicked,
        false,
      );

      this.#isStatusPageIndex = true;
      return [configurationFound, true];
    } else if (temporaryData) {
      this.pageSize.set(temporaryData?.currentPageSize);
      this.currentPageIndex.set(temporaryData?.currentPageIndex);
      this.toggleCompactMode(
        temporaryData?.lastRowClickedData,
        temporaryData?.lastRowClicked,
        false,
      );
      this.#isStatusPageIndex = true;
      return [false, true];
    } else {
      return [configurationFound, false];
    }
  }

  async toggleCompactMode(
    data: any,
    rowNumber?: number,
    deselect: boolean = true,
    silent: boolean = false,
  ) {
    if (
      (!data || JSON.stringify(data) === '{}' || rowNumber == undefined) &&
      !deselect
    ) {
      return;
    }
    if (!deselect) {
      const clonedRow = jsonDeepClone(data);
      if (rowNumber !== undefined) {
        this.lastRowClickedIndex.set(rowNumber);
      }
      const originalIndex = rowNumber ?? this.lastRowClickedIndex() ?? 0;
      this.#lastRowClickedData.set(clonedRow);
      const compactRow = {
        ...clonedRow,
        __initialRowIndex: originalIndex,
      };
      if (!silent) {
        this.rowClicked.emit(clonedRow);
      }
      this.setEmptyRowHeight();
      await this.#resetColumnWidths();
      return;
    } else {
      this.#lastRowClickedData.set(undefined);
      this.lastRowClickedIndex.set(undefined);
      if (!silent) {
        this.rowClicked.emit({});
      }
      return;
    }
  }

  async scrollGrid(row?: number | Record<string, any>) {
    if (this.compactViewActive()) {
      return;
    }
    if (!this.gridId()) {
      return;
    }
    const selectedRowIndex = this.#resolveRowIndex(row);
    if (selectedRowIndex === undefined || selectedRowIndex === null) {
      return;
    }
    if (!Number.isInteger(selectedRowIndex) || selectedRowIndex < 0) {
      return;
    }
    if (row && typeof row === 'object') {
      this.lastRowClickedIndex.set(selectedRowIndex);
    }
    const rowSelector = '#' + this.gridId() + '-row-' + selectedRowIndex;
    if (rowSelector.includes('undefined')) {
      return;
    }
    const selectedRowElement = $(rowSelector);
    if (selectedRowElement && selectedRowElement.length > 0) {
      this.#scrollSelectedRowIntoView(selectedRowElement.get(0));
      // Remove the selection classes from all rows in the grid before adding to the new one
      $(`#${this.gridId()} .sia-row`).removeClass(
        'sia-mat-grid-row--fixed-selected sia-mat-grid-row--selected',
      );

      if (this.isMultiGrid() && !this.allowCompact()) {
        selectedRowElement
          .get(0)!
          .classList.add('sia-mat-grid-row--fixed-selected');
      } else {
        selectedRowElement.get(0)!.classList.add('sia-mat-grid-row--selected');
      }
    }
  }

  #resolveRowIndex(row?: number | Record<string, any>): number | undefined {
    if (typeof row === 'number' && Number.isFinite(row)) {
      return row;
    }

    if (row && typeof row === 'object') {
      if (typeof row.__initialRowIndex === 'number') {
        return row.__initialRowIndex;
      }

      const compareByPrimaryKey = () => {
        const pk = row['__primary-key'];
        if (!pk) {
          return undefined;
        }
        const pkString = typeof pk === 'string' ? pk : JSON.stringify(pk);

        const datasets = [this.dataSource() ?? [], this.#initialData ?? []];
        for (const dataset of datasets) {
          const index = dataset.findIndex((item: any) => {
            if (!item) {
              return false;
            }
            const itemPk = item['__primary-key'];
            if (!itemPk) {
              return false;
            }
            const itemPkString =
              typeof itemPk === 'string' ? itemPk : JSON.stringify(itemPk);
            return itemPkString === pkString;
          });
          if (index !== -1) {
            return index;
          }
        }
        return undefined;
      };

      const compareByTempId = () => {
        if (row.__tempId === undefined || row.__tempId === null) {
          return undefined;
        }
        const datasets = [this.dataSource() ?? [], this.#initialData ?? []];
        for (const dataset of datasets) {
          const index = dataset.findIndex(
            (item: any) => item?.__tempId === row.__tempId,
          );
          if (index !== -1) {
            return index;
          }
        }
        return undefined;
      };

      const byPrimaryKey = compareByPrimaryKey();
      if (byPrimaryKey !== undefined) {
        return byPrimaryKey;
      }

      const byTempId = compareByTempId();
      if (byTempId !== undefined) {
        return byTempId;
      }

      if (row.__isAdding) {
        return 0;
      }
    }

    if (typeof this.lastRowClickedIndex() === 'number') {
      return this.lastRowClickedIndex();
    }

    return undefined;
  }

  async toggleRowFromIndex(rowIndex: number) {
    if (!this.#initialData) {
      return;
    }
    this.toggleCompactMode(
      this.#initialData[rowIndex],
      rowIndex,
      this.lastRowClickedIndex() == rowIndex && !this.#lastRowClickedOnScript(),
    );
    this.saveStatus();
    this.#firstLoadData = true;
    await this.scrollGrid();
  }

  async cellClick(data: any, rowNumber: number, column?: SiaGridColConfig) {
    if (!column?.scriptOnClick) {
      if (!this.isMultiGrid()) {
        return;
      } else {
        await this.toggleRowFromIndex(rowNumber);
      }
      this.#lastRowClickedOnScript.set(false);
      return;
    }
    let previousSelectedRow = document.getElementById(
      this.gridId() + '-row-' + this.lastRowClickedIndex(),
    );
    if ((!this.compactViewActive() || rowNumber === 0) && !this.isMultiGrid()) {
      this.lastRowClickedIndex.set(rowNumber);
    }
    if (
      (!column?.scriptOnClick && !this.focusClickedRow()) ||
      (this.focusClickedRow() && !column)
    ) {
      this.rowClicked.emit(this.#initialData![rowNumber]);
    }
    previousSelectedRow?.classList.remove('sia-mat-grid-row--focused');
    if ((this.focusClickedRow() && !column) || !this.focusClickedRow()) {
      let selectedRow = document.getElementById(
        this.gridId() + '-row-' + this.lastRowClickedIndex(),
      );
      selectedRow?.classList.add('sia-mat-grid-row--focused');
    }

    let canClick = true;
    if (column.scriptClickEnabled) {
      canClick = await this.execScript(column.scriptClickEnabled, {
        row: data,
        cell: data[column.dataField?.toLowerCase() ?? ''],
      });
    }
    if (canClick) {
      this.lastRowClickedIndex.set(rowNumber);
      this.saveStatus();
      if (!this.compactViewActive()) {
        this.#lastRowClickedOnScript.set(true);
      }
      await this.execScript(column.scriptOnClick, {
        row: data,
        cell: data[column.dataField?.toLowerCase() ?? ''],
      });
    } else {
      this.#lastRowClickedOnScript.set(false);
    }
  }
  async openHeaderFilterList(column: SiaGridColConfig, menu: MatMenuTrigger) {
    const currentCol = this.#columns().find((x) => x.id === column.dataField);
    if (!currentCol) {
      return;
    }
    this.#currentFilterMenuTrigger = menu;
    const hasDataSource = !!currentCol.headerFilterDataSource?.length;

    if (hasDataSource) {
      menu.openMenu();
      return;
    }

    this.showHeaderFilterSpinner.set(true);
    menu.openMenu();

    try {
      const params: SiaGridPageRequest = jsonDeepClone(this.#loadDataParams);
      params.headerFilterColumn = column.dataField;
      const menuData = await this.#siaGridService.loadHeaderFilterData(params);

      this.#columns.update((cols) => {
        return cols.map((col) => {
          if (col.id === column.dataField) {
            return { ...col, headerFilterDataSource: menuData ?? [] };
          }
          return col;
        });
      });
    } finally {
      this.showHeaderFilterSpinner.set(false);
    }
  }

  isPrimaryKeyToIdentifyWithHashtag(columnId?: string) {
    return this.#primaryKeysToIdentifyWithHashtag.includes(columnId ?? '');
  }

  selectHeaderFilterItem(
    event: Event,
    column: SiaGridColumnInstance,
    itemId: string,
  ) {
    event.preventDefault();
    event.stopPropagation();
    this.#columns.update((cols) => {
      return cols.map((col) => {
        if (col.id !== column.id || !col.headerFilterDataSource) {
          return col;
        }
        const updatedDataSource = col.headerFilterDataSource.map((item) =>
          item.id === itemId ? { ...item, selected: !item.selected } : item,
        );
        const updatedFilterValue = updatedDataSource
          .filter((x) => x.selected)
          .map((x) => x.id);
        return {
          ...col,
          headerFilterDataSource: updatedDataSource,
          headerFilterValue: updatedFilterValue,
        };
      });
    });
  }

  toggleHeaderFilterSelection(column: SiaGridColumnInstance) {
    this.#columns.update((cols) => {
      return cols.map((col) => {
        if (col.id !== column.id || !col.headerFilterDataSource) {
          return col;
        }
        const someSelected = col.headerFilterDataSource.some((x) => x.selected);
        const updatedDataSource = col.headerFilterDataSource.map((x) => ({
          ...x,
          selected: !someSelected,
        }));
        const updatedFilterValue = updatedDataSource
          .filter((x) => x.selected)
          .map((x) => x.id);
        return {
          ...col,
          headerFilterDataSource: updatedDataSource,
          headerFilterValue: updatedFilterValue,
        };
      });
    });
  }

  async applyHeaderColumnFilter(column: SiaGridColumnInstance) {
    const menuTrigger = this.#currentFilterMenuTrigger;
    if (menuTrigger) {
      menuTrigger.closeMenu();
    }
    await this.loadData();
  }

  async #buildDataSource() {
    // 1) Preparo i dati (clono + group)
    let data = jsonDeepClone(this.#initialData) ?? [];

    // Handle the single editing row if it exists
    let addingRow: any[] = [];
    if (this.#editingRow) {
      if (this.#editingRow.__isAdding) {
        // Adding row goes to the top
        addingRow = [this.#editingRow];
      } else {
        // Editing existing row - remove the old version from data and add the edited version
        const editingPrimaryKey = this.#editingRow['__primary-key'];
        if (editingPrimaryKey) {
          data = data.filter((d: any) => {
            if (!d['__primary-key']) {
              return true;
            }
            return (
              JSON.stringify(editingPrimaryKey) !==
              JSON.stringify(d['__primary-key'])
            );
          });
        }
        // Add the editing row back with its modifications
        data.push(this.#editingRow);
      }
    }

    if (!this.configuration().group?.groupDataField) {
      // Without grouping, keep adding records at the top
      this.dataSource.set([...addingRow, ...data]);
    } else {
      let dataGroupped = this.groupBy(
        data,
        this.#reducedGroups,
        this.#columns().find(
          (c) =>
            c.colConfig.dataField ===
            this.configuration().group?.groupDataField,
        )?.colConfig,
      );
      this.dataSource.set([...addingRow, ...dataGroupped]);
    }

    // reset cache di stili
    this.#rowStyles = {};
    this.#rowStylesInProgress = [];

    // 2) Per ogni riga e colonna eseguo getCellStyle() e getCellClass() in parallelo
    let indexLastRow: number = this.dataSource().findIndex(
      (index) => index.isLastRow,
    );
    let dataToUpdate = this.dataSource();
    if (indexLastRow < 0 && !this.showTemplate()) {
      dataToUpdate.push({ isLastRow: true });
    } else if (indexLastRow >= 0) {
      dataToUpdate.splice(indexLastRow, 1);
      dataToUpdate.push({ isLastRow: true });
    }
    // 3) Attendo tutti i task, poi aggiorno il view
    // Create a temporary map to hold the new styles
    const newStyleMap: Record<string, { style: string; class: string }> = {};
    const tasks: Promise<any>[] = [];

    // Execute getCellStyle and getCellClass for each cell, populating the map
    dataToUpdate.forEach((rowData, rowIndex) => {
      this.columns().forEach((colInst) => {
        // Style calculation
        tasks.push(
          this.getCellStyle(rowData, colInst.colConfig, rowIndex).then(
            (style) => {
              const key = `${rowIndex}_${colInst.id}`;
              if (!newStyleMap[key]) {
                newStyleMap[key] = { style: '', class: '' };
              }
              newStyleMap[key].style = style;
            },
          ),
        );

        // Class calculation
        tasks.push(
          this.getCellClass(rowData, colInst.colConfig).then((cls) => {
            const key = `${rowIndex}_${colInst.id}`;
            if (!newStyleMap[key]) {
              newStyleMap[key] = { style: '', class: '' };
            }
            newStyleMap[key].class = cls;
          }),
        );
        tasks.push(this.getActionIcon(rowData, colInst.colConfig));
        tasks.push(this.getActionText(rowData, colInst.colConfig));
      });
    });

    await Promise.all(tasks);
    this.dataSource.set([...dataToUpdate]);
    this.styleSignals.set(newStyleMap);

    this.#updateMatTableStickyStyle();
    this.siaSizeDetector.renderPopup(this.pageData()?.guid ?? '', true);
    this.dataSourceBuilt.set(true);
    this.#scheduleOnce(100, 'skeletonBuilt', () => {
      this.showSkeleton.set(false);
    });
    if (this.showTemplate() && !this.pageSize()) {
      this.#scheduleOnce(50, 'auto-fill-template', () =>
        this.#ensureTemplateScrollable(),
      );
    }
  }

  #ensureTemplateScrollable() {
    // Guard: Only works for template mode without fixed page size
    if (!this.showTemplate()) return;
  }

  #updateMatTableStickyStyle() {
    // se non ho la MatTable, esco subito
    if (!this.matTable) {
      return;
    }
    const tableAny: any = this.matTable as any;
    const attempt = (retry: boolean) => {
      try {
        const contentDefs = tableAny._contentColumnDefs?.toArray?.() ?? [];
        const customDefs = tableAny._customColumnDefs?.toArray?.() ?? [];
        const allDefs = [...contentDefs, ...customDefs];
        // Se alcune definizioni non sono ancora pronte rimando l'aggiornamento (una sola volta)
        if (allDefs.some((d: any) => !d || !d.name)) {
          if (!retry) {
            this.#scheduleOnce(30, 'retry-sticky-styles', () => attempt(true));
          }
          return;
        }
        tableAny.updateStickyColumnStyles();
        tableAny.updateStickyFooterRowStyles();
        this.#scheduleOnce(50, 'retry-sticky-header', () => {
          try {
            tableAny.updateStickyHeaderRowStyles();
          } catch {
            /* header non ancora pronto */
          }
        });
      } catch {
        // ignoro errori runtime non critici
      }
    };
    // eseguo fuori da Angular per ridurre change detection extra
    this.#ngZone.runOutsideAngular(() => attempt(false));
  }

  sortColumn(column: SiaGridColumnInstance) {
    if (!column.colConfig.allowSorting) {
      return;
    }
    column.orderByDirection =
      column.orderByDirection == 'asc'
        ? 'desc'
        : !column.orderByDirection
          ? 'asc'
          : undefined;
    if (!this.#pressingCtrl) {
      this.#columns()
        .filter((x) => x.id != column.id)
        .forEach((x) => {
          x.orderByDirection = undefined;
          x.sortIndex = undefined;
        });
    }
    if (column.orderByDirection && !column.sortIndex) {
      column.sortIndex =
        Math.max(0, ...this.#columns().map((x) => x.sortIndex ?? 0)) + 1;
    }
    this.#columns()
      .filter((x) => x.orderByDirection)
      .sort((a, b) => (a.sortIndex ?? 0) - (b.sortIndex ?? 0))
      .forEach((column, index) => {
        column.sortIndex = index + 1;
      });
    if (!column.orderByDirection) {
      column.sortIndex = undefined;
    }
    if (this.#configurationProcessed) {
      this.loadData();
    }
  }
  getHeaderClass(column: SiaGridColumnInstance) {
    let className = column.colConfig.allowHeaderFiltering
      ? 'sia-mat-grid-header-row__header-filter'
      : 'sia-mat-grid-header-row__header';
    // className += " sia-mat-grid-header-row--" + column.colConfig.alignment;
    if (column.headerFilterValue && column.headerFilterValue.length > 0) {
      className += ' sia-mat-grid-header-row--active';
    }
    column.colConfig.headerClass = className;
    return className;
  }
  openGroupByMenu(event: MouseEvent, menuTrigger: any) {
    event.preventDefault();
    menuTrigger.openMenu();
  }
  async swapGroupByColumn(col: SiaGridColumnInstance) {
    if (
      !this.configuration().group ||
      !this.configuration().group!.groupDataField
    )
      return;
    this.configuration().group!.groupDataField = col.colConfig.dataField;
    this.groupByChips()[0] = col;
    // Aggiorna la griglia se necessario
    this.#reducedGroups = [];

    await this.loadData(true);
  }
  setEmptyRowHeight() {
    if (this.showTemplate()) {
      return;
    }
    const $emptyRows = $('.' + this.gridId() + ' .sia-empty-row');
    if (!$emptyRows || $emptyRows.length === 0) {
      this.#scheduleOnce(200, 'set-empty-row-height-retry', () =>
        this.setEmptyRowHeight(),
      );
      return;
    }
    var fullTableHeight = $('#' + this.gridId()).height();
    var currentHeight = 0;
    while (currentHeight != fullTableHeight) {
      fullTableHeight = currentHeight;
      currentHeight = $('#' + this.gridId()).height() ?? 0;
    }
    let headerHeight = $('#' + this.gridId() + ' thead').height();
    let footerHeight = $('#' + this.gridId() + ' tfoot').height();
    if (!fullTableHeight || !headerHeight) {
      return;
    }
    let remainingHeight = fullTableHeight - headerHeight - (footerHeight ?? 0);
    let bodyHeigh = 0;
    $('#' + this.gridId() + ' .sia-row').map((index, element) => {
      if (element) {
        bodyHeigh += $(element).height() ?? 0;
      }
    });

    remainingHeight = remainingHeight - bodyHeigh - 6;

    // If remaining height is too small hide the empty-row
    if ((remainingHeight ?? 0) <= 20) {
      $emptyRows.attr('style', 'display: none !important');
    } else {
      // ensure a non-negative integer height
      const h = Math.max(0, Math.round(remainingHeight));
      $emptyRows.attr('style', 'height: ' + h + 'px !important; ');
    }
  }
  customReducer(
    accumulator: any,
    currentValue: any,
    groupByDataField: string[],
    groupByColumnName: string,
    groupLevel: number,
    columnConfig?: SiaGridColConfig,
    collapsedGroups?: any[],
    previousGroupName?: string,
  ) {
    let currentGroup: any = {};
    groupByDataField.forEach((element) => {
      currentGroup[element] = currentValue[element]
        ? currentValue[element]
        : '';
    });
    let groupId = '';
    groupByDataField.forEach((element) => {
      groupId += currentValue[element];
    });
    let parentId = '';
    for (let index = 0; index < groupByDataField.length - 1; index++) {
      const element = groupByDataField[index];
      parentId += currentValue[element];
    }

    if (!accumulator[JSON.stringify(currentGroup)]) {
      let nameColValue = currentValue[groupByColumnName];
      let groupItem: any = {
        groupId: groupId,
        parentId: parentId,
        groupName: nameColValue
          ? `${this.i18nService.translate(columnConfig?.groupText ?? '')} ${nameColValue}`
          : '',
        value: currentGroup,
        isGroup: true,
        reduced: collapsedGroups?.some((group) => group.value == currentGroup),
        propertyName: groupByColumnName,
        groupLevel: groupLevel, // +1 perche
      };
      accumulator[JSON.stringify(currentGroup)] = {
        group: groupItem,
        data: [],
      };
    }
    accumulator[JSON.stringify(currentGroup)].data.push(currentValue);
    return accumulator;
  }
  groupBy(data: any[], reducedGroups?: any[], columnConfig?: SiaGridColConfig) {
    let collapsedGroups = reducedGroups;
    if (!reducedGroups) collapsedGroups = [];
    let groupedData: { [key: string]: { group: any; data: any[] } } = {};
    if (data && data.length == 0) {
      // return this.reducedGroups.sort(
      //   (a, b) =>
      //     (this.gridGroups ?? []).findIndex((x) => x.groupId == a.value) -
      //     (this.gridGroups ?? []).findIndex((x) => x.groupId == b.value),
      // );
    } else {
      groupedData = data.reduce(
        (accumulator, currentValue) =>
          this.customReducer(
            accumulator,
            currentValue,
            [this.configuration().group?.groupDataField ?? ''],
            this.configuration().group?.groupNameDataField ||
              this.configuration().group?.groupDataField ||
              '',
            0,
            columnConfig,
            collapsedGroups,
            '',
          ),
        {} as { [key: string]: { group: any; data: any[] } },
      );
      if (
        this.configuration().subGroups &&
        this.configuration().subGroups!.length > 0
      ) {
        for (let key in groupedData) {
          let groupArr = groupedData[key].data;
          groupedData[key].data = this.#reduceForSubGroups(
            groupArr,
            this.configuration().subGroups ?? [],
            1,
            0,
            [this.configuration().group?.groupDataField ?? ''],
          );
        }
      }
    }
    let currentStartData = this.#loadDataParams.skip!;
    const groupsLine: {
      groupId: string;
      isStart: boolean;
      isEnd: boolean;
      groupIndex: number;
      groupLevel: number;
      groupName: string;
      count: number;
      propertyName: string;
      parentId: string;
    }[] = [];
    this.#createGroupLine(groupsLine, columnConfig ?? {}, 0);
    this.#currentVisibleInLineGroups = jsonDeepClone(groupsLine);
    if (this.totalCount() == 0 && this.#reducedGroups.length > 0) {
      this.#reducedGroups.forEach((group) => {
        var groupItem: any = {
          groupName: `${this.i18nService.translate(this.configuration().group?.groupText ?? '')} ${group.groupName}`,
          value: group.value,
          isGroup: true,
          reduced: true,
        };
        if (
          this.#gridGroups?.findIndex((x) => x.groupId == group.value) != -1
        ) {
          groupedData[groupItem.value] = {
            group: groupItem,
            data: [],
          };
        }
      });
    } else {
    }

    groupedData = jsonDeepClone(this.#sortGroupedData(groupedData));
    let res: any[] = [];
    this.#flattenGroups(groupedData, res);
    this.#insertHiddenGroupsInRes(res, groupsLine);

    return res;
  }
  #insertHiddenGroupsInRes(
    res: any[],
    groupsLine: {
      groupId: string;
      isStart: boolean;
      isEnd: boolean;
      groupIndex: number;
      groupLevel: number;
      groupName: string;
      count: number;
      propertyName: string;
      parentId: string;
    }[],
  ) {
    // Ordinare i gruppi chiusi secondo la mia linea del tempo
    let clonedReducedGroups = [
      ...this.#reducedGroups.map((x) => ({
        ...x,
        isParentReduced: false,
      })),
      ...this.#parentsGroupsToShow.map((x) => ({
        ...x,
        isParentReduced: true,
      })),
    ];
    clonedReducedGroups = clonedReducedGroups.filter(
      (x) => res.findIndex((y) => y.groupId == x.groupId) == -1,
    );
    this.#sortGroupsBasedOnLineOrder(groupsLine, clonedReducedGroups);
    clonedReducedGroups = clonedReducedGroups.filter(
      (x) => groupsLine.findIndex((y) => y.groupId == x.groupId) != -1,
    );
    clonedReducedGroups
      .filter((x) => !x.isParentReduced)
      .forEach((groupRow: any) => {
        let groupsChild: any[] = this.#currentVisibleInLineGroups.filter(
          (x) => x.parentId == groupRow.groupId,
        );
        groupsChild?.forEach((x) => {
          clonedReducedGroups = clonedReducedGroups.filter(
            (y: any) => y.groupId != x.groupId,
          );
        });
      });

    this.#insertGroupsInres(groupsLine, res, clonedReducedGroups);
  }
  #insertGroupsInres(
    groupsLine: {
      groupId: string;
      isStart: boolean;
      isEnd: boolean;
      groupIndex: number;
      groupLevel: number;
      groupName: string;
      count: number;
      propertyName: string;
      parentId: string;
    }[],
    res: any[],
    groups: any[],
  ): any[] {
    let maxLevel = 0;
    res.forEach((elem) => {
      if (maxLevel < elem.groupLevel) {
        maxLevel = elem.groupLevel;
      }
    });
    let groupsByLevel = groups.reduce((acc, item) => {
      const level = item.groupLevel;
      if (!acc[level]) {
        acc[level] = [];
      }
      acc[level].push(item);
      return acc;
    }, {});

    // Sort keys ascending and create ordered object
    const sortedDict: any = {};
    Object.keys(groupsByLevel)
      .sort((a, b) => Number(a) - Number(b))
      .forEach((key) => {
        sortedDict[key] = groupsByLevel[key];
      });

    Object.keys(sortedDict).forEach((level) => {
      let levelGroups = sortedDict[level];
      levelGroups.forEach((group: any) => {
        let clonedGroupsLine: any[] = jsonDeepClone(groupsLine);

        let currentGroupIndex = clonedGroupsLine.findIndex(
          (x) => x.groupId == group.groupId,
        );
        clonedGroupsLine = this.removeGroupsWithParent(
          clonedGroupsLine,
          group.groupId,
        );
        if (currentGroupIndex + 1 < clonedGroupsLine.length) {
          let nextGroup = clonedGroupsLine[currentGroupIndex + 1];

          let resIndex = res.findIndex(
            (x) => x.isGroup == true && x.groupId == nextGroup.groupId,
          );
          if (resIndex >= 0) {
            res.splice(resIndex, 0, group);
          }
        } else if (
          this.totalCount() == 0 ||
          this.currentPageIndex() ==
            Math.ceil(this.totalCount()! / this.currentPageSize()) - 1
        ) {
          res.push(group);
        }
      });
    });
    return res;
  }
  removeGroupsWithParent(clonedGroupsLine: any[], groupId: any): any[] {
    if (!groupId) return clonedGroupsLine;

    const toRemove = new Set<string>();
    const stack: string[] = [groupId];

    while (stack.length > 0) {
      const current = stack.pop()!;
      // Salta la root, aggiungi solo i discendenti
      if (current !== groupId) {
        toRemove.add(current);
      }

      const children = clonedGroupsLine.filter((x) => x.parentId === current);
      children.forEach((child) => stack.push(child.groupId));
    }

    return clonedGroupsLine.filter((x) => !toRemove.has(x.groupId));
  }
  #sortGroupsBasedOnLineOrder(
    groupsLine: {
      groupId: string;
      isStart: boolean;
      isEnd: boolean;
      groupIndex: number;
      groupLevel: number;
      groupName: string;
      count: number;
      propertyName: string;
      parentId: string;
    }[],
    groups: any[],
  ) {
    groups = groups.sort((a, z) => {
      return (
        groupsLine.findIndex((x) => x.groupId == z.groupId) -
        groupsLine.findIndex((x) => x.groupId == a.groupId)
      );
    });
  }
  #sortGroupsBasedOnLineOrderDesc(
    groupsLine: {
      groupId: string;
      isStart: boolean;
      isEnd: boolean;
      groupIndex: number;
      groupLevel: number;
      groupName: string;
      count: number;
      propertyName: string;
      parentId: string;
    }[],
    groups: any[],
  ) {
    groups = groups.sort((a, z) => {
      return (
        groupsLine.findIndex((x) => x.groupId == a.groupId) -
        groupsLine.findIndex((x) => x.groupId == z.groupId)
      );
    });
  }
  #flattenGroups(groupItem: any, result?: any[]): any[] {
    if (!result) {
      result = [];
    }
    if (Object.keys(groupItem).includes('group')) {
      result.push(groupItem.group);
      if (Array.isArray(groupItem.data)) {
        result.push(...groupItem.data);
      } else {
        this.#flattenGroups(groupItem.data, result);
      }
    } else {
      const sortedKeys = Object.keys(groupItem).sort((a, b) =>
        a.localeCompare(b),
      );
      for (const key of Object.keys(groupItem)) {
        this.#flattenGroups(groupItem[key], result);
      }
    }
    return result;
  }
  #createGroupLine(
    groupsLine: {
      groupId: string;
      isStart: boolean;
      isEnd: boolean;
      groupIndex: number;
      groupLevel: number;
      propertyName: string;
      groupName: string;
      count: number;
      parentId: string;
    }[],
    textConfig: SiaGridColConfig,
    index: number,
  ) {
    if (!this.#gridGroups) {
      return;
    }

    let subGroupIndex = 0;
    let groupCounts: { [key: string]: number } = {};

    // Calcola i contatori bottom-up
    for (let group of this.#gridGroups) {
      let groupId = '';
      let groupLevel = 0;
      let parentGroupId = '';
      for (const key of Object.keys(group).filter((k) => k !== 'count')) {
        groupId += group[key];
        if (groupsLine.findIndex((x) => x.groupId === groupId) == -1) {
          subGroupIndex += 1;
          if (!(groupId in groupCounts)) {
            groupCounts[groupId] = 0;
          }
          // groupCounts[groupId] += parseInt(group['count']);
          groupsLine.push({
            groupId: groupId,
            groupIndex: subGroupIndex,
            groupLevel: groupLevel,
            isStart: false, // primo gruppo a questo livello nel gruppo corrente
            isEnd: false, // ultimo gruppo a questo livello nel gruppo corrente
            propertyName: key,
            groupName: '',
            count: parseInt(group['count']),
            parentId: parentGroupId,
          });
        }
        parentGroupId = groupId;
        groupLevel++;
      }
    }
  }
  #reduceForSubGroups(
    data: any[],
    subGroups: Group[],
    level: number,
    propertyIndex: number,
    previousDatafield: string[],
  ): any | any[] {
    if (propertyIndex >= subGroups.length) {
      return data;
    }
    let groupedData: { [key: string]: { group: any; data: any[] } } = {};
    let groupByDataField = subGroups[propertyIndex].groupDataField ?? '';
    let groupByColumnName =
      subGroups[propertyIndex].groupNameDataField || groupByDataField;
    groupedData = data.reduce(
      (accumulator, currentValue) =>
        this.customReducer(
          accumulator,
          currentValue,
          [...previousDatafield, groupByDataField],
          groupByColumnName,
          level,
          this.#columns().find(
            (c) => c.colConfig.dataField === groupByDataField,
          )?.colConfig,
          [],
        ),
      {} as { [key: string]: { group: any; data: any[] } },
    );

    if (!groupedData) {
      return groupedData;
    }

    for (let key in groupedData) {
      let groupArr = groupedData[key].data;
      if (groupArr && groupArr.length > 0) {
        groupedData[key].data = this.#reduceForSubGroups(
          groupArr,
          subGroups,
          level + 1,
          propertyIndex + 1,
          [...previousDatafield, groupByDataField],
        );
      }
    }

    return groupedData;
  }
  #sortGroupedData(groupedData: {
    [key: string]: { group: any; data: any[] };
  }): { [key: string]: { group: any; data: any[] } } {
    const sortedKeys = Object.keys(groupedData).sort((a, b) =>
      a.localeCompare(b),
    );
    const sortedGroupedData: { [key: string]: { group: any; data: any[] } } =
      {};
    for (const key of sortedKeys) {
      let sortedSubGroup = groupedData[key];
      if (
        Array.isArray(sortedSubGroup.data) &&
        sortedSubGroup.data.length > 0 &&
        typeof sortedSubGroup.data[0] === 'object' &&
        'group' in sortedSubGroup.data[0] &&
        'data' in sortedSubGroup.data[0]
      ) {
        const subGroupObj = sortedSubGroup.data.reduce(
          (acc, item) => {
            acc[item.group] = item;
            return acc;
          },
          {} as { [key: string]: any },
        );
        const sortedSubGroupObj = this.#sortGroupedData(subGroupObj);
        sortedSubGroup = {
          group: sortedSubGroup.group,
          data: Object.values(sortedSubGroupObj),
        };
      }
      sortedGroupedData[key] = sortedSubGroup;
    }
    return sortedGroupedData;
  }
  setPageAfterClosingGroup() {
    this.#sortGroupsBasedOnLineOrderDesc(
      this.#currentVisibleInLineGroups,
      this.#reducedGroups,
    );
    let clonedGroupsLine: any[] = jsonDeepClone(
      this.#currentVisibleInLineGroups,
    );
    this.#reducedGroups.forEach((gr) => {
      clonedGroupsLine = this.removeGroupsWithParent(
        clonedGroupsLine,
        gr.groupId,
      );
    });
    let maxLevel = 0;
    let totCount = 0;
    clonedGroupsLine.forEach((elem) => {
      if (maxLevel < elem.groupLevel) {
        maxLevel = elem.groupLevel;
      }
    });
    for (let i = 0; i < clonedGroupsLine.length; i++) {
      if (clonedGroupsLine[i].groupId == this.#lastGroupReduced.groupId) break;
      if (
        clonedGroupsLine[i].groupLevel == maxLevel &&
        this.#reducedGroups.findIndex(
          (x) => x.groupId == clonedGroupsLine[i].groupId,
        ) == -1
      ) {
        totCount += clonedGroupsLine[i].count;
      }
    }
    let newPageIndex =
      totCount == 0 ? 0 : Math.ceil(totCount / this.currentPageSize()) - 1;
    if (newPageIndex != this.currentPageIndex()) {
      this.currentPageIndex.set(newPageIndex);
    }
  }
  isGroup(index: number, item: any): boolean {
    return item.isGroup;
  }

  isNotGroup(index: number, item: any): boolean {
    return !item.isGroup;
  }
  hasSelected(data: any[]): boolean {
    return Array.isArray(data) && data.some((item) => item.selected);
  }
  extractSelectedKeys(): any[] {
    let selectedKeys: any[] = [];
    this.selectedRows()?.selected?.forEach((x) => {
      let rowKeys: any = {};
      let data = JSON.parse(x);
      this.#primaryKeys.forEach((key) => {
        rowKeys[key] = data[key];
      });
      selectedKeys.push(rowKeys);
    });
    return selectedKeys;
  }
  extractRowKeys(row: any): any[] {
    let rowKeys: any = {};
    this.#columns().forEach((col) => {
      if (
        col.colConfig.dataField &&
        (col.colConfig.primaryKey || col.colConfig.dataField?.startsWith('__'))
      ) {
        rowKeys[col.colConfig.dataField] = row[col.colConfig.dataField];
      }
    });
    return rowKeys;
  }
  rowToJson(row: any): string {
    return JSON.stringify(this.extractRowKeys(row) ?? {});
  }
  reduceGroup(groupRow: any) {
    groupRow.reduced = !groupRow.reduced;
    let group = this.#currentVisibleInLineGroups.find(
      (x) => x.groupId == groupRow.groupId,
    );

    if (groupRow.reduced) {
      this.#reducedGroups.push(groupRow);
      this.#parentsGroupsToShow = this.#parentsGroupsToShow.filter(
        (x) => x.groupId != groupRow.groupId,
      );
    } else {
      this.#reducedGroups = this.#reducedGroups.filter(
        (el) => el?.groupId != groupRow.groupId,
      );
      let groupChild = this.#currentVisibleInLineGroups.filter(
        (x) => x.parentId == groupRow.groupId,
      );
      if (
        this.#parentsGroupsToShow.findIndex(
          (x) => x.groupId == groupRow.groupId,
        ) == -1 &&
        groupChild.some(
          (x) =>
            this.#reducedGroups.findIndex((y) => y.groupId == x.groupId) != -1,
        )
      ) {
        this.#parentsGroupsToShow.push(groupRow);
      }
    }

    let parentGroupLine = this.dataSource().find(
      (x) => x.isGroup == true && x.groupId == group.parentId,
    );
    let allParentsChild: any[] = [];
    while (!!parentGroupLine) {
      let currentChild = this.#currentVisibleInLineGroups.filter(
        (x) => x.parentId == parentGroupLine.groupId,
      );
      while (currentChild.length > 0) {
        allParentsChild.push(...currentChild);
        let subChild: any[] = [];
        currentChild.forEach((x) => {
          subChild.push(
            ...this.#currentVisibleInLineGroups.filter(
              (y) => y.parentId == x.groupId,
            ),
          );
        });
        currentChild = subChild;
      }
      if (
        this.#parentsGroupsToShow.findIndex(
          (x) => x.groupId == parentGroupLine.groupId,
        ) == -1 &&
        allParentsChild.some(
          (x) =>
            this.#reducedGroups.findIndex((y) => y.groupId == x.groupId) != -1,
        )
      ) {
        this.#parentsGroupsToShow.push(parentGroupLine);
      } else if (
        !allParentsChild.some(
          (x) =>
            this.#reducedGroups.findIndex((y) => y.groupId == x.groupId) != -1,
        )
      ) {
        this.#parentsGroupsToShow = this.#parentsGroupsToShow.filter(
          (x) => x.groupId != parentGroupLine.groupId,
        );
      }
      parentGroupLine = this.dataSource().find(
        (x) => x.isGroup == true && x.groupId == parentGroupLine.parentId,
      );
    }

    this.#lastGroupReduced = groupRow;
    this.setPageAfterClosingGroup();

    if (this.#configurationProcessed) {
      this.loadData(true);
    }
  }
  trackByFn = (index: number, item: any): any => {
    if (!item['__primary-key']) {
      let extractedKeys = this.extractRowKeys(item);
      if (
        extractedKeys &&
        extractedKeys instanceof Object &&
        Object.keys(extractedKeys).length > 0
      ) {
        item['__primary-key'] = JSON.stringify(extractedKeys);
      } else {
        item['__primary-key'] = JSON.stringify(Guid.create().toString());
      }
    }
    return item['__primary-key'];
  };
  ngOnInit() {
    super.ngOnInit();
    // 1) Azioni
    this.#siaActionsService
      .actionFired$()
      .pipe(takeUntil(this.#destroy))
      .subscribe((af: SiaActionFired) => {
        if (
          af.guid === this.pageData()?.guid &&
          af.componentId === this.gridId() &&
          af.action
        ) {
          this.#manageActionFired(af.action, af.actionTrigger);
        }
      });

    // 2) SignalR refresh
    this.siaSignalrService.refreshMessage$
      .pipe(takeUntil(this.#destroy))
      .subscribe(async (msg) => await this.manageSiaSignalrMessage(msg));

    // 4) Resize
    this.siaSizeDetector.onResize$
      .pipe(takeUntil(this.#destroy))
      .subscribe(async (size: SiaWindowSize | null) => {
        if (!this.#configurationProcessed || !this.dataSourceBuilt) {
          return;
        }
        if (
          size?.height &&
          size?.width &&
          (this.#previousWindowSize[0] != size?.height ||
            this.#previousWindowSize[1] != size?.width)
        ) {
          this.#previousWindowSize = [size.height, size.width];
          await this.#processTemplateVisibility();
          await this.#resetColumnWidths();
        } else if (
          this.#columns()
            .filter((x) => x.colConfig.currentWidth && x.isActive)
            .reduce((acc, col) => acc + (col.colConfig.currentWidth ?? 0), 0) <
          (size?.contentWidth ?? 0)
        ) {
          this.#columns()
            .filter((x) => !x.colConfig.width)
            .map((x) => {
              x.colConfig.currentWidth = undefined;
              x.widthSetted = false;
            });
          await this.reassignColumnsWidth();
        }
      });

    // 5) Route changes (per uscita full-screen)
    this.siaRouterService.routeChanged$
      .pipe(takeUntil(this.#destroy))
      .subscribe(() => {
        if (
          this.fullScreen() &&
          this.siaRouterService
            .getLatestRoutingData()
            ?.outlet?.includes('drawer')
        ) {
          this.fullScreen.set(false);
          this.exitFullscreenMode();
        }
        this.#updateMatTableStickyStyle();
      });
  }
  async #processTemplateVisibility() {
    const deviceType =
      this.siaSizeDetector.currentSize?.deviceType?.toLowerCase() ?? 'desktop';
    if (this.configuration() && this.configuration().template) {
      const initialShowTemplate = this.showTemplate();
      let showTemplate = this.showTemplate();
      switch (this.configuration().showTemplate) {
        case 'both':
          showTemplate = true;
          break;
        case 'mobile':
          showTemplate = this.siaSizeDetector.currentSize.isMobile ?? false;
          break;
        case 'desktop':
          showTemplate = !this.siaSizeDetector.currentSize.isMobile;
          break;
        case 'tablet':
          showTemplate = deviceType == 'tablet' || deviceType == 'mobile';
          break;
        default:
          showTemplate = false;
          break;
      }

      if (!this.#privateTemplatePerspective) {
        const perspectives =
          await this.#siaComponentConfigService.getComponentPerspectives(
            'grid-template-view',
            this.gridId() ?? '',
          );
        if (!perspectives || perspectives.length == 0) {
          if (initialShowTemplate !== showTemplate) {
            this.showTemplate.set(showTemplate);
            this.showBodySkeleton.set(true);
            if (!showTemplate) {
              this.resetColumnWidths();
            }
            if (this.#configurationProcessed) {
              await this.loadData(true);
              return;
            }
          } else {
            this.showTemplate.set(showTemplate);
          }
          await this.reassignColumnsWidth();
          return;
        }
        this.#privateTemplatePerspective = perspectives[0];
        this.#privateTemplateVisibility = JSON.parse(
          this.#privateTemplatePerspective.jsonConfig ?? '{}',
        );
      }
      if (
        this.#privateTemplatePerspective &&
        this.#privateTemplateVisibility &&
        this.selectedGridView()?.id
      ) {
        const configVisibility =
          this.#privateTemplateVisibility[this.selectedGridView()!.id!];
        if (configVisibility && deviceType in configVisibility) {
          showTemplate =
            configVisibility[deviceType as keyof typeof configVisibility] !==
            undefined
              ? !!configVisibility[deviceType as keyof typeof configVisibility]
              : showTemplate;
        }
      }

      this.showTemplate.set(showTemplate);

      if (
        initialShowTemplate !== showTemplate &&
        this.#configurationProcessed
      ) {
        this.showBodySkeleton.set(true);
        if (!showTemplate) {
          this.resetColumnWidths();
        }
        await this.loadData(true);
      } else {
        await this.reassignColumnsWidth();
      }
    }
  }
  async ngAfterViewInit() {
    this.#viewInitialized = true;
    if (this.gridId()) {
      this.selectedGridView.set(undefined);
    }
    if (this.paginatorEl()?.nativeElement) {
      this.#ngZone.runOutsideAngular(() => {
        const ro = new ResizeObserver(() => {
          // offsetHeight can change without contentRect changing in some cases,
          // so always re-measure the element.
          this.#ngZone.run(() =>
            this.paginatorHeight.set(
              this.paginatorEl()?.nativeElement.offsetHeight ?? 0,
            ),
          );
        });
        ro.observe(this.paginatorEl()?.nativeElement!);
        this.#destroyRef.onDestroy(() => ro.disconnect());
      });
    } else {
      console.warn('Paginator element not found for grid', this.gridId());
    }
  }
  drop(
    event: CdkDragDrop<
      {
        id: string;
        description: string;
        selected: boolean | undefined;
        visibleIndex?: number;
      }[]
    >,
  ) {
    const chooser = this.columnChooserColumns().slice();
    if (!chooser.length) return;

    moveItemInArray(chooser, event.previousIndex, event.currentIndex);

    // aggiorna UI chooser
    this.columnChooserColumns.set(chooser);

    // posizioni globali attuali delle colonne del chooser (ordinate)
    const positions = chooser
      .map((x) => this.#columns().findIndex((c) => c.id === x.id))
      .filter((i) => i >= 0)
      .sort((a, b) => a - b);

    if (positions.length !== chooser.length) return;

    // colonne reali riordinate
    const reorderedCols = chooser.map(
      (x) => this.#columns().find((c) => c.id === x.id)!,
    );

    // riscrivi SOLO quelle posizioni nel globale
    const next = this.#columns().slice();
    for (let i = 0; i < positions.length; i++) {
      next[positions[i]] = reorderedCols[i];
    }

    // riallinea visibleIndex su tutto (opzionale ma consigliato)
    next.forEach((c, idx) => (c.visibleIndex = idx));

    // nuova reference per refresh UI
    this.#columns.set(next);
  }
  async #sortColumnChooser() {
    for (let index = 0; index < this.columnChooserColumns.length; index++) {
      const element = this.columnChooserColumns()[index];
      const foundColumn = this.#columns().find((x) => x.id == element.id);
      if (foundColumn) {
        foundColumn.visibleIndex = index;
      }
    }
  }
  getEmptyRowHeight() {
    this.#scheduleOnce(100, 'setEmptyRowHeight', () => {
      this.setEmptyRowHeight();
    });
  }

  resetColumnWidths() {
    this.#scheduleOnce(100, 'resetColumnWidths', () => {
      this.#resetColumnWidths(false);
    });
  }
  async #resetColumnWidths(reassignWidth = true) {
    if (!this.dataSource() || this.showTemplate()) {
      return;
    }
    this.#gridColumnsWidthSet.set(false);
    this.#columns().map((x) => {
      x.colConfig.currentWidth = reassignWidth
        ? undefined
        : x.colConfig.currentWidth;
      x.widthSetted = false;
      // $('.' + this.gridId() + ' .mat-column-' + x.id)?.css('width', '');
    });

    await this.reassignColumnsWidth();
  }
  ngOnDestroy() {
    // Cancel any pending HTTP request when navigating away
    if (this.#requestId) {
      this.#httpService.cancelRequest('grid-core/cancel', this.#requestId);
      this.#requestId = undefined;
    }

    this.#destroy.next();
    this.#destroy.complete();
    // 1) Ripristina gli stili che avevamo salvato in full-screen
    this.#restoreParentStyles();

    // 2) Salva lo stato della griglia in sessione/se memoria
    this.saveStatus();

    // 3) Pulisce eventuali timer e observer
    clearInterval(this.#continuousLoadingIntervalId);
    clearTimeout(this.#applyFiltersTimeout);

    // 4) Cancella tutti i subscription RxJS personalizzati
    this.#subs.forEach((sub) => sub.unsubscribe());
    this.#subs = [];
    this.groupByChips.set([]);

    this.#timeouts.forEach((t) => clearTimeout(t));

    // Clear all scheduled timeouts
    Object.values(this.#scheduledTimeouts).forEach((timeoutId: any) =>
      clearTimeout(timeoutId),
    );
    this.#scheduledTimeouts = {};

    super.ngOnDestroy();
  } /** Cancella tutti i timeout pianificati (usato al cambio grid) */
  #cancelAllScheduledTimeouts() {
    for (const k of Object.keys(this.#scheduledTimeouts)) {
      clearTimeout(this.#scheduledTimeouts[k]);
      delete this.#scheduledTimeouts[k];
    }
  }
  getDescription(desc: string | null) {
    if (desc === null) {
      return '(' + this.i18nService.translate('vuoto') + ')';
    }
    return desc;
  }
  async loadTemplateData() {
    if (
      this.totalCount() &&
      this.totalCount()! >
        this.currentPageIndex() * this.currentPageSize() +
          this.currentPageSize()
    ) {
      this.lastRowClickedIndex.set(undefined);
      this.currentPageIndex.update((value) => value + 1);
      if (this.#configurationProcessed) {
        await this.loadData(false, true);
      }
    }
  }
}
